import { ASTOCK_LIST } from "../astock";

export default {
  root: {
    title: "TradingX: Algorithmic Trading & Liquidity Provider",
  },
  header: {
    menu: {
      tradingx: "TradingX",
      service: {
        title: "Services",
        subItems: {
          marketmaker: "Market Making",
          digitalAssetManagement: "Asset Management",
          advisory: "Advisory",
        },
      },
      about: {
        title: "About",
        subItems: {
          aboutUs: "About Us",
          aboutCareer: "Careers",
        },
      },
      contactUs: "Contact Us",
    },
  },
  home: {
    menuItem: {
      production: "TradingX",
      service: "Service",
      about: "About",
      contact: "Contact Us",
    },
    intro: {
      whoWeArePart1: "We're ",
      whoWeArePart2: "a leading global ",
      whoWeArePart3: "algorithmic trading ",
      whoWeArePart4: "firm ",
      whoWeArePart5: "",
      whatWeDo:
        "We address liquidity and efficiency challenges in the markets through technology and trading, helping sophisticated investors achieve financial outcomes while driving the development of the economy.",
      tradingVolumn: "Trading Volume",
      scientificBasis: "Scientific Data",
      client: "Clients",
    },
    services: {
      title: "The Intersection of Technology and Finance",
      content:
        "Building intelligent, dynamic trading systems to drive efficient capital allocation and financial innovation.",
      aiResearch: {
        title: "AI Research",
        subtitle: "Unleashing the power of AI",
        content:
          "We delve deep into AI, creating outstanding algorithms and training models, leveraging AI's capabilities to identify market opportunities and mitigate risks, expanding financial frontiers, and delivering higher efficiency and success to algorithmic trading.",
      },
      marketmaker: {
        title: "Market Making",
        subtitle: "An essential role in markets",
        content:
          "As a market maker, we integrate disciplines like mathematics, finance, and computer science, providing liquidity to the market through deep expertise and superior trading capabilities, enhancing accessibility and maintaining stability and efficiency in markets.",
      },
      crypto: {
        title: "Multi-market portfolio allocation",
        subtitle: "A new paradigm of wealth growth",
        content:
          "We specialize in quantitative hedging while driving technological innovation and financial revolution. Our portfolio spans U.S. equities, crypto assets, and RWA, achieving multi-dimensional risk diversification and alpha capture.",
      },
    },
    cooperatorCarousel: {
      title: "Collaborating with Global Leading Enterprises",
    },
    exploration: {
      text: "Start here to discover the charm of algorithmic trading",
    },
  },

  product: {
    header: {
      title: "The Ultimate Partner in Asset Management",
      content:
        "Top-tier trading dashboard, advanced strategies, high-quality execution, and deep liquidity aggregation provide white-glove service for professional traders to trade effortlessly in any market cycle.",
    },
    products: {
      trade: {
        title: "Trade",
        content: {
          aggregateTransaction: {
            subtitle: "Aggregation Trading",
            desc1:
              "Connects major trading platforms, aggregates market depth, and executes complex trading plans on a single platform.",
            desc2: "",
          },
          engine: {
            subtitle: "Efficient Execution Engine",
            desc1:
              "Swift execution, maintains low latency and high throughput, ensuring immediate and precise trading.",
            desc2: "",
          },
          tradingview: {
            subtitle: "Integrated TradingView Advanced Components",
            desc1:
              "A high-end, professional financial data visualization tool that supports multi-market analysis and multi-indicator overlay, helping traders make informed decisions. For example, experience professional market data visualization through the ",
            desc2: " price trend chart.",
          },
        },
      },
      aiTrade: {
        title: "AI Trading",
        content: {
          algorithmFrame: {
            subtitle: "Leading Algorithm Framework",
            desc: "Integrates research from financial engineering, mathematics, and AI to deploy best-in-class algorithmic trading frameworks.",
          },
          riskSmartManagement: {
            subtitle: "Smart Risk Management",
            desc: "Quantitative analysis of potential market risks, real-time strategy adjustments, ensuring secure trading.",
          },
          strategyOptimization: {
            subtitle: "Adaptive Strategy Optimization",
            desc: "AI systems rapidly identify opportunities and learn from real-time market data, adaptively optimizing strategies for consistent investment returns.",
          },
          solvingStrategy: {
            subtitle: "Advanced Quantitative Strategies",
            desc: "AI technology supports decision-making for quantitative strategies. Market-making strategies leverage AI to provide liquidity, maximize returns, and effectively manage risks.",
          },
        },
      },
      accountManagement: {
        title: "Unified Account Management",
        content: {
          assetManagement: {
            key: "account-1",
            subtitle: "Integrated Fund Management",
            desc: "Cross-platform asset management and settlement, simplifying fund management processes.",
          },
          maximizeEfficiency: {
            subtitle: "Maximizing Fund Efficiency",
            desc: "Efficient fund scheduling to optimize and utilize funds effectively.",
          },
        },
      },
      dataAnalysis: {
        title: "Data Analysis",
        content: {
          marketInsight: {
            subtitle: "In-depth Market Insights",
            desc: "Deep data mining and analysis, generating market insight reports to assist decision-making.",
          },
          transactionDataAnalysis: {
            subtitle: "Trading Data Analysis",
            desc: "Investment reports and feedback, including investment return analysis and execution quality evaluation, comprehensively monitoring financial status and portfolio performance.",
          },
        },
      },
    },
    startup: {
      header: {
        title:
          "Algorithmic Trading Platform Designed for Professional Investors",
        content:
          "We've gathered the brightest minds from various disciplines to create everything needed to explore financial technology and achieve our ambitions together.",
      },
      list: {
        quantitativeTrading: "AI Quantitative Trading",
        deepLiquidity: "Deep Liquidity",
        customizableStrategy: "Customizable Strategies",
        investmentAnalysis: "Data and Investment Analysis",
      },
      button: {
        text: "Want to break through investment boundaries? Start here.",
      },
    },
  },
  marketMaker: {
    banner: {
      title: {
        part1: "Market Maker ",
        part2: "injecting Vital Liquidity into Market",
      },
      content:
        "Liquidity is a critical metric for assets to trade quickly without causing price fluctuations.",
    },
    intro: {
      title: "About Market Maker",
      content:
        "Market makers act as the 'central nervous system' of markets. They respond quickly to market signals, coordinate buy and sell orders, ensure timely information dissemination, and smooth execution of trades, thereby creating liquidity in the market. Market makers are crucial for market stability and efficiency by stabilizing prices and providing immediate trading opportunities.",
    },
    style: {
      title: "TradingX's Market Making Style",
      content:
        "As a market maker in the crypto market, TradingX reduces the costs of capital allocation and market innovation, injecting vital liquidity into markets to provide seamless trading experiences for global traders, investment institutions, and market participants.",
      styles: {
        flow: {
          subtitle: "Liquidity",
          content:
            "Collaborating deeply with the world's leading exchanges to provide stronger liquidity.",
        },
        dataAnalysis: {
          subtitle: "Data Analysis",
          content:
            "Powerful and reliable databases generate intelligent reports promptly, enabling faster and more accurate decision-making.",
        },
        algorithmTrade: {
          subtitle: "Market-making Algorithm",
          content:
            "The market-making algorithm incorporates the latest AI technology, providing the market with an efficient and accurate liquidity solution.",
        },
        experience: {
          subtitle: "Experience",
          content:
            "Familiarity with project and exchange trading ecosystem requirements, offering customized services.",
        },
      },
    },
    tip: "Liquidity is crucial for exchanges. Order books with low liquidity often have large spreads and volatility, making it difficult for buyers and sellers to trade at appropriate prices. Ensuring asset liquidity allows both sides to trade quickly at any time.",
    contact: {
      title: "If You Need",
      lyrics: {
        enhanceLiquidity: {
          title: "Enhance Liquidity",
          content: "Reduce bid-ask spreads and improve trading efficiency.",
        },
        stabilizePrice: {
          title: "Stabilize Price",
          content:
            "Mitigate price fluctuations and maintain stability in the trading ecosystem.",
        },
        manageCostsNRisks: {
          title: "Manage Costs and Risks",
          content:
            "Precise entry and exit points to minimize trading slippage.",
        },
        institutionalLevelServices: {
          title: "Institutional-Level Services",
          content: "Support large-scale trading demands.",
        },
        solution: {
          title: "Solutions",
          content: "Liquidity strategies, crypto investment consulting, etc.",
        },
      },
    },
    joinUs: {
      content:
        "Need a reliable partner? Our team is ready to assist you anytime!",
      button: {
        text: "Contact Us",
      },
    },
  },
  digitalAssetManagement: {
    banner: {
      title: "Asset Management",
      content:
        "Leading AI algorithmic trading system and robust liquidity ensure consistent and stable investment returns.",
    },
    management: {
      title: "Asset Management",
      content: {
        part1:
          "Utilize our validated algorithms to achieve investment returns in any market environment.",
        part2:
          "Our services and support enable more investors to effectively participate in stocks, digital assets, and RWA, etc.",
      },
      AMIs: {
        am1: {
          subtitle: "Liquidity and Market Access",
          content:
            "Extensive market access and efficient liquidity management ensure optimal asset allocation globally.",
        },
        am2: {
          subtitle: "AI-Enhanced Strategies",
          content:
            "We enhance strategy capabilities through AI, continuously optimize trading models for advanced insights and execution.",
        },
        am3: {
          subtitle: "Robust Investment Performance",
          content:
            "With advanced quantitative trading strategies and execution, we achieve investment returns in any market environment.",
        },
        am4: {
          subtitle: "Risk Management and Compliance",
          content:
            "Our comprehensive risk management framework integrates compliance standards to ensure transparency and asset security.",
        },
        am5: {
          subtitle: "Third-Party Custody",
          content:
            "Support of third-party custody services to mitigate counterparty risks.",
        },
        am6: {
          subtitle: "Customized Investment Solutions",
          content:
            "We offer personalized investment solutions based on client goals and risk preferences for tailored asset management.",
        },
      },
    },
    tip: "The market is known for its violent price swings, complex technology, and ever-changing regulatory environment, which together form a highly volatile and intricate investment field. Posing challenges for investors to identify and evaluate genuine investment opportunities.",
    issue: {
      title: "Challenges Faced by Investors",
      content: {
        c1: "Access barriers and fragmented infrastructure prevent seamless multi-asset allocation across markets.",
        c2: "Opaque market depth makes it difficult to discern the authenticity of market data and reports, leading to investment errors.",
        c3: "Low execution quality complicates handling large trades, increasing risks such as high slippage.",
        c4: "Emotion-driven decision-making during market volatility leads to irrational decisions.",
      },
    },
    sciManagement: {
      title: "Scientific Asset Management",
      content:
        "We apply scientific methods to analyze the asset market, strategically invest based on precise trading models, and achieve stable investment returns even in bear markets.",
      SMs: {
        sm1: {
          subtitle: "Algorithm Execution",
          content:
            "Automatically follow trading rules, facilitate high-quality execution, reducing human errors.",
        },
        sm2: {
          subtitle: "Trading Systems",
          content:
            "Our systems ensure low-latency, high-throughput global trading, ensuring excellent trading performance.",
        },
        sm3: {
          subtitle: "Data Network",
          content:
            "Identify complex markets, reliable basis for investment decisions.",
        },
        sm4: {
          subtitle: "Diversified Strategies",
          content:
            "Factor research is our expertise, combining AI to form predictable, autonomously optimized diversified strategies.",
        },
        sm5: {
          subtitle: "Risk Management",
          content:
            "Comprehensive risk control system monitors strategy performance in real-time, ensuring stable investment execution.",
        },
        sm6: {
          subtitle: "White-Glove Service",
          content:
            "24x7 institutional-level white-glove service provides clients with a secure asset investment experience.",
        },
      },
    },
    contact: {
      text: "If you need a trusted partner, please contact us.",
      button: {
        text: "Contact Us",
      },
    },
  },
  advisory: {
    banner: {
      title: "Advisory Services",
      content1: "Finding elegant solutions to complex problems",
      content2:
        "TradingX offers in-depth and comprehensive advisory services, leveraging rich expertise, industry insights, and advanced technology to effectively navigate market dynamics and create value for clients. Our advisory services primarily target financial institutions, projects, and high-net-worth individuals.",
    },
    advisory: {
      AIs: {
        FI: {
          subtitle: "Financial Institutions",
          subContent:
            "We understand the challenges financial institutions face in exploring the crypto industry: market complexity, future uncertainty, and interdisciplinary knowledge demands. With in-depth experience in traditional financial and a multidisciplinary approach to innovation, we tailor personalized solutions to help financial institutions accurately identify risks, capture opportunities, and achieve robust asset growth and long-term success in the unpredictable crypto market.",
          subItems: {
            fi1: {
              name: "Entry into Crypto Markets",
            },
            fi2: {
              name: "Investment Strategy Advisory",
            },
            fi3: {
              name: "Algorithmic Trading",
            },
            fi4: {
              name: "FinTech Research",
            },
            fi5: {
              name: "Risk Management",
            },
            fi6: {
              name: "Liquidity Management",
            },
          },
        },
        project: {
          subtitle: "Projects",
          subContent:
            "We provide comprehensive consulting and customized solutions for projects to address challenges in token issuance and market lifecycle management. Leveraging our technology and deep liquidity to achieve higher market penetration and risk management. We collaborate with ambitious projects planning to list on top-tier exchanges.",
          subItems: {
            p1: {
              name: "Liquidity Management",
            },
            p4: {
              name: "Ecosystem Development",
            },
            p5: {
              name: "Risk Management",
            },
          },
        },
        HNWI: {
          subtitle: "High-Net-Worth Individuals",
          subContent:
            "Multi market portfolio investment holds immense potential but also comes with skepticism and challenges. Market opacity, technological complexity, and the lack of asset management professionalism often leave individual investors confused and uncertain. We specialize in addressing these concerns, reducing barriers to crypto investments, and minimizing friction for investors.",
          subItems: {
            hnwi1: {
              name: "Market Insights and Analysis",
            },
            hnwi2: {
              name: "Customized Asset Management",
            },
            hnwi3: {
              name: "Algorithmic Trading",
            },
            hnwi4: {
              name: "FinTech Research",
            },
            hnwi5: {
              name: "Risk Management",
            },
            hnwi6: {
              name: "24/7 Dedicated Customer Service",
            },
          },
        },
      },
    },
    contact: {
      left: {
        h1: "Make TradingX an accelerator for driving the development of your asset strategy.",
        button: "Contact Us",
      },
      right: {
        h1: "Related Services",
        list: {
          l1: "TradingX",
          l2: "Market Maker",
          l3: "Asset Management",
        },
      },
    },
  },
  aboutUs: {
    banner: {
      left: {
        title: "About TradingX",
        content1:
          "TradingX is a leading algorithmic trading firm that enhances market seamlessness and accessibility through algorithms, expanding the boundaries of finance. As a global liquidity provider, we continuously inject vitality into the market, driving efficiency, transparency, and innovation in the market.",
        content2:
          "Our members focus on technology development and financial innovation. We’re dynamic problem solvers. We believe in the future of FinTech and maintain patience and creativity.",
      },
      right: {
        stats: {
          stat1: {
            name: "Trading Volume",
          },
          stat2: {
            name: "Scientific Basis",
          },
          stat3: {
            name: "Clients",
          },
          stat4: {
            name: "Customer Service",
          },
        },
      },
    },
    duty: {
      title: "Our Mission",
      content1: "We’re a leading global algorithmic trading firm, ",
      content2:
        "Our mission is to continuously expand the boundaries of finance, empower market participants, and promote market transparency, fairness, and efficiency.",
    },
    values: {
      header: {
        title: "Our Values",
        content:
          "Our values bring together like-minded talents from around the globe, fostering close collaboration to create a leading algorithmic trading ecosystem, collectively promoting the prosperity of FinTech.",
      },
      valuesItems: {
        v1: {
          title: "Integrity",
          content:
            "We adhere to the highest ethical and legal standards as guidelines for behavior, maintaining sincerity and responsibility.",
        },
        v2: {
          title: "Precision",
          content:
            "We uphold a precise and meticulous attitude, striving for high standards and quality in research, decision-making, and execution processes.",
        },
        v3: {
          title: "Openness",
          content:
            "We foster an open work environment, advocating for collisions of diverse thoughts and interdisciplinary exchanges to build an outstanding team.",
        },
        v4: {
          title: "Innovation",
          content:
            "We dare to break boundaries, explore the unknown, and continuously transcend ourselves through innovation to drive industry progress.",
        },
        v5: {
          title: "Winning",
          content:
            "We constantly improve and increase our winning rate, defeating opponents in market competition. We explore new strategies to help clients overcome challenges.",
        },
        v6: {
          title: "Mutuality",
          content:
            "We establish long-term cooperative relationships of mutual benefit with clients, partners, and members, sharing growth and success.",
        },
      },
    },
    ourTeam: {
      header: {
        title: "Integrated Team",
        content:
          "Our team consists of top talents in financial, mathematical sciences, engineering, and other fields, driving financial technology innovation and achieving our common mission.",
      },
      ourTeamItems: {
        ot1: {
          title: "AI Research",
          content:
            "Our expert team is committed to AI technology research to achieve self-optimization of trading algorithms and market adaptability.",
        },
        ot2: {
          title: "Engineering",
          content:
            "Our engineering team focuses on building scalable, highly reliable infrastructure to ensure system availability and low latency, meeting the demands of large-scale trading.",
        },
        ot3: {
          title: "Market & Trading",
          content:
            "The market and trading team, with their profound insights into the market, execute precise trading operations while managing and hedging market risks to achieve a robust trading performance.",
        },
        ot4: {
          title: "Quantitative Research",
          content:
            "The quantitative research team excels in mathematical models and statistics, discovering subtle connections in volatile markets and constructing complex algorithms driving trades.",
        },
        ot5: {
          title: "Business Consulting",
          content:
            "Our business consulting team provides customized solutions, helping clients understand markets, formulate strategies, and achieve business goals.",
        },
      },
    },
    solve: {
      header: {
        title: "What We Solve",
        content: "We solve complex market problems through our expertise.",
      },
      solveArounds: {
        sa1: {
          name: "Research & Deployment",
        },
        sa2: {
          name: "Risk Management",
        },
        sa3: {
          name: "Investment Research & Analysis",
        },
        sa4: {
          name: "Digital Asset Management",
        },
        sa6: {
          name: "Liquidity Management",
        },
        sa8: {
          name: "Customized Services",
        },
      },
    },
  },
  aboutCareer: {
    banner: {
      h1: "Career Opportunities",
      h2: "Craft Iterative Life Strategies to Realize Your Ambitions.",
      p1: {
        part1:
          "We gather talent from diverse backgrounds to build a free, diverse team.",
        part2:
          "Achieving our ambitions through exploring the unknown and tackling challenges that opponents cannot solve.",
      },
      p2: "We are ambitious and passionate about algorithmic trading. If you are too, apply now!",
    },
    job: {
      header: {
        title: "Open Positions",
      },
      jobs: {
        quantitativeResearcher: {
          name: "Quantitative Researcher",
        },
        engineer: {
          name: "Senior Engineer",
        },
        trader: {
          name: "Trader",
        },
        applyButton: {
          text: "Apply",
        },
      },
    },
    careers: {
      quantitativeResearcher: {
        name: "Quantitative Researcher",
        remote: {
          location: "Hong Kong",
          mode: "Full-time",
        },
        applyButton: {
          text: "Apply Now",
        },
        finding: {
          f1: "We are looking for individuals who are passionate about mathematics and excel in developing automated trading algorithms. You should have a talent for creation and backtesting, excel in generating Alpha and creating automated strategies. You will work closely with traders and developers to propose hypotheses, collect and analyze data to develop new algorithms.",
          f2: "TradingX is looking for Senior Quantitative Researchers, this is a rare opportunity to join a leading global algorithmic trading firm. We value talent with diverse backgrounds and creativity, encouraging them to fully unleash their potential. At TradingX, you will have the chance to solve meaningful problems alongside geniuses from various fields and become an expert in cutting-edge domains. We strive to care for our employees by providing competitive incentives, benefits, and rewards.",
        },
        candidate: {
          title: "Our Ideal Candidate:",
          needs: {
            n1: {
              content:
                "Over 2 years of experience in quantitative research, especially in market making pricing and hedging strategies.",
            },
            n2: {
              content:
                "Master's degree or above in econometrics, mathematics, physics, statistics, computer science, or related disciplines.",
            },
            n3: {
              content:
                "Deep understanding of the market microstructure of digital assets, proficiency in at least one programming language such as Java, Python, or C++.",
            },
            n4: {
              content:
                "Experience in low-latency trading systems, strong mathematical and statistical abilities.",
            },
            n5: {
              content:
                "Excellent logical thinking and problem-solving skills, ability to work under pressure and take responsibility.",
            },
            n6: {
              content:
                "Competitive, continuously learning, proactive, good at collaboration, possess excellent communication skills. Proficiency in English is a plus.",
            },
          },
        },
        todos: {
          title: "What You Will Do:",
          td1: {
            content:
              "Collaborate with traders and the engineering team to optimize and innovate trading strategies.",
          },
          td2: {
            content:
              "Conduct in-depth research and analysis of data, identify and utilize market patterns.",
          },
          td3: {
            content:
              "Design and implement complex quantitative models and automated trading algorithms.",
          },
        },
      },
      engineer: {
        name: "Senior Engineer",
        remote: {
          location: "Hong Kong",
          mode: "Full-time",
        },
        applyButton: {
          text: "Apply Now",
        },
        finding: {
          f1: "Our engineers collaborate with researchers and traders to solve large-scale complex problems. Our team can quickly implement ideas, and the market provides rapid feedback.",
          f2: "TradingX is looking for Senior Engineers, this is a rare opportunity to join a global leader in algorithmic trading. We value talent with diverse backgrounds and creativity, encouraging them to fully unleash their potential. At TradingX, you will have the chance to solve meaningful problems alongside professionals from various fields and become an expert in cutting-edge domains. We strive to care for our employees by providing competitive incentives, benefits, and rewards.",
        },
        candidate: {
          title: "Our Ideal Candidate:",
          needs: {
            n1: {
              content:
                "Master's degree in computer science, engineering, statistics, mathematics, physics, or related fields.",
            },
            n2: {
              content:
                "Excellent design and programming skills, ability to work with multiple programming languages.",
            },
            n3: {
              content:
                "Ability to assist and effectively communicate in a complex and highly technical team environment.",
            },
            n4: {
              content:
                "Curiosity and enthusiasm for solving challenging problems using technology.",
            },
            n5: {
              content:
                "Strong analytical skills, familiarity with probability and statistics.",
            },
            n6: {
              content:
                "Experience in fintech companies, ability to conduct blockchain development.",
            },
          },
        },
        todos: {
          title: "What You Will Do:",
          td1: {
            content:
              "Design and develop financial market products, including low-latency algorithmic trading platforms.",
          },
          td2: {
            content: "Implement, verify, and execute software testing.",
          },
          td3: {
            content:
              "Support researchers and traders to ensure algorithm implementation.",
          },
          td4: {
            content:
              "Create and maintain documentation, write functional and design specifications.",
          },
          td5: {
            content: "Customize and improve systems according to requirements.",
          },
          td6: {
            content:
              "Code development and debugging, including relevant automated units and integration testing.",
          },
        },
      },
      trader: {
        name: "Trader",
        remote: {
          location: "Hong Kong",
          mode: "Full-time",
        },
        applyButton: {
          text: "Apply Now",
        },
        finding: {
          f1: "Our traders collaborate with researchers and engineers to implement great ideas and achieve better results.",
          f2: "TradingX is looking for Traders, this is a rare opportunity to join a global leader in algorithmic trading. We value talent with diverse backgrounds and creativity, encouraging them to fully unleash their potential. At TradingX, you will have the chance to solve meaningful problems alongside geniuses from various fields and become an expert in cutting-edge domains. We strive to care for our employees by providing competitive incentives, benefits, and rewards.",
        },
        candidate: {
          title: "Our Ideal Candidate:",
          needs: {
            n1: {
              content:
                "Master's degree in finance, economics, mathematics, statistics, or related fields.",
            },
            n2: {
              content:
                "At least 2 years of experience in trading in the crypto industry.",
            },
            n3: {
              content:
                "Extensive understanding of financial markets and trading strategies, especially market making.",
            },
            n4: {
              content:
                "Strong analytical, quantitative, and interpersonal skills.",
            },
            n5: {
              content:
                "Ability to assess risks and opportunities related to new tokens.",
            },
            n6: {
              content:
                "Ability to manage complex trades and positions, stay updated on crypto market trends and regulatory changes.",
            },
            n7: {
              content:
                "Competitive, continuously learning, proactive, good at collaboration.",
            },
            n8: {
              content:
                "Excellent communication skills, proficiency in English is a plus.",
            },
          },
        },
        todos: {
          title: "What You Will Do:",
          td1: {
            content:
              "Possess extensive knowledge of digital asset trading and experience in trading on global exchanges.",
          },
          td2: {
            content:
              "Collaborate with ICO issuers to facilitate primary market trading and ensure timely and efficient execution.",
          },
          td3: {
            content:
              "Identify potential market making opportunities and optimize strategies.",
          },
          td4: {
            content:
              "Provide insights into the market, formulate plans, identify risks, and execute complex trades on a large scale.",
          },
          td5: {
            content:
              "Enhance the overall profitability of our digital asset business.",
          },
        },
      },
      application: {
        title: "Fill out Application Form",
        applyForm: {
          candidateInfo: {
            h1: "Candidate Information",
            name: {
              label: "Name",
              placeholder: "How should we address you",
            },
            resume: {
              label: "Resume",
              placeholder: "Upload your resume (.pdf, .doc)",
            },
            phone: {
              label: "Phone",
              placeholder: "Your mobile number",
            },
            email: {
              label: "Email",
              placeholder: "Your email address",
            },
            currentCompany: {
              label: "Current Company",
              placeholder: "Your company name",
            },
          },
          candidateLinks: {
            h1: "Links",
            linkedIn: {
              label: "LinkedIn URL",
              placeholder: "Your LinkedIn URL",
            },
            github: {
              label: "Github URL",
              placeholder: "Your Github URL",
            },
            combine: {
              label: "Combined URL",
              placeholder: "Your combined URL",
            },
            other: {
              label: "Other URL",
              placeholder: "Your other URL",
            },
          },
          candidateExtra: {
            h1: "Additional Information",
            p: "Add cover letter or any other content you want to share",
          },
          submitButton: {
            text: "Submit",
          },
          notification: {
            submit: {
              success: {
                message: "Submission successful",
                description:
                  "Your application form has been successfully submitted!",
              },
              error: {
                message: "Submission failed",
                description:
                  "Failed to submit application form. Please contact the administrator.",
              },
            },
          },
          Rules: {
            ResumeRule: {
              IsNotNull: "Resume/CV cannot be empty",
              IsOversize: "Resume file is too large, limit is 10MB",
            },
          },
        },
      },
    },
  },
  contactUs: {
    banner: {
      text: "Contact TradingX",
    },
    contact: {
      h1: "Please complete the provided form to contact with us.",
      formItems: {
        firstName: {
          placeholder: "First Name*",
        },
        lastName: {
          placeholder: "Last Name*",
        },
        email: {
          placeholder: "Email*",
        },
        telegram: {
          placeholder: "Telegram*",
        },
        company: {
          placeholder: "Company*",
        },
        position: {
          placeholder: "Position",
        },
        interest: {
          placeholder: "Interested In*",
          options: {
            opt1: {
              name: "TradingX",
            },
            opt2: {
              name: "Asset Management",
            },
            opt3: {
              name: "Market Maker",
            },
            opt4: {
              name: "Partnership Relations",
            },
          },
        },
        business: {
          placeholder: "Business*",
          options: {
            opt1: {
              name: "Hedge Fund",
            },
            opt2: {
              name: "Venture Fund",
            },
            opt3: {
              name: "Institutional Wealth Manager",
            },
            opt4: {
              name: "Financial Intermediary",
            },
            opt5: {
              name: "Proprietary Trader",
            },
            opt6: {
              name: "Financial Infrastructure Provider",
            },
            opt7: {
              name: "High Net Worth Individual",
            },
            opt8: {
              name: "Other",
            },
          },
        },
        assetRange: {
          placeholder: "AUM Range*",
          options: {
            opt1: {
              name: "<1M",
            },
            opt2: {
              name: "1M-10M",
            },
            opt3: {
              name: "10M-100M",
            },
            opt4: {
              name: "100M-500M",
            },
            opt5: {
              name: "500M-1B",
            },
            opt6: {
              name: ">1B",
            },
          },
        },
        country: {
          placeholder: "Country*",
        },
        submitButton: {
          text: "Submit",
        },
      },
    },
  },
  footer: {
    media: {
      title: "Social Media",
    },
    production: {
      title: "Products",
      tradingx: "TradingX",
    },
    about: {
      title: "About",
      aboutUs: "About Us",
      career: "Career",
    },
    service: {
      title: "Services",
      marketMaker: "Market Making",
      digitalAssetManagement: "Asset Management",
      consultationService: "Advisory",
      serviceObject: "",
    },
    contact: {
      title: "Contact Us",
      contact: "Contact",
    },
  },

  sider: {
    trade: "Trade",
    account: "Account",
    AITrade: "AI Trade",
    TradeData: "Trade Data",
    data: "Data",
    Settings: "Settings",
  },
  dashboardTrade: {
    PleaseSelectPosition: "Please select position",
    AllClosePosition: "Selected one-click close position",
    SyncMode: "Sync Mode",
    Cont: "Cont",
    Lot: "Lot",
    IsHideMin: "Hide Small Assets",
    IsShowZero: "Show Zero Assets",
    Asset: "Asset",
    Query: "Search",
    OpenLong: "Open Long",
    CloseShort: "Close Short",
    open: "Open",
    close: "Close",
    Spot: "Spot",
    Index: "Index",
    Futures: "Futures",
    Forex: "Forex",
    AStock: "A Stock",
    AStock_SH: "A Stock(SH)",
    AStock_SZ: "A Stock(SZ)",
    CloseLong: "Close Long",
    OpenShort: "Open Short",
    USDFutures: "USDⓈ-M Futures",
    COINFutures: "COIN-M Futures",
    Perpetual: "Perpetual",
    Quarterly: "Quarterly",
    Currently: "Quarterly",
    DayChange: "Change",
    DayHigh: "High",
    DayLow: "Low",
    DayVolumeone: "Volume",
    DayVolumetwo: "Amount",
    Day: "Day",
    Shares: "Shares",

    DayOpenPrice: "Today Open",
    DayPreClosePrice: "Yesterday Close",
    DayUpperLimit: "Upper Limit",
    DayLowerLimit: "Lower Limit",

    Price: "Price",
    Amount: "Amount",
    Total: "Total",
    Buy: "Buy",
    Sell: "Sell",
    Limit: "Limit",
    MaxBuy: "Max Buy",
    Available: "Avbl",
    Balance: "Balance",
    AcceptQuotesSpread: "Accept Spread",
    QuickMode: "Quick Mode",
    Market: "Market",
    LogIn: "Log In",
    TriggerOrder: "TP/SL",
    TriggerPrice: "Trigger Price",
    Tradeatthebestprice: "Execute at the best price",
    ActivateAccount: "Activate Account",
    SwitchMainAccount: "Switch Main Account",
    Markets: "Markets",
    Depth: "Depth",
    OpenOrders: "Open Orders",
    SubAccount: "Sub-account",
    Pair: "Pair",
    Time1: "Time",
    Side: "Side",
    Amount1: "Amount",
    Total1: "Total",
    FilledAmount: "Filled Amount",
    TotalFilled: "Total Filled",
    AveragePrice: "Avg Price",
    ExecutionTime: "Time",
    Status: "Status",
    CancelAllOrder: "Cancel All",

    MarginSmallLiability: "Small Liability Conversion",
    MarginSmallBnb: "Small BNB Conversion",
    PortfolioMarginRepay: "Margin Repay",
    PortfolioContractAutoRepay: "Contract Auto Repay",
    PortfolioAutoCollect: "Auto Collect",

    ConfirmMarginSmallLiability:
      "Confirm to execute small liability conversion?",
    ConfirmMarginSmallBnb: "Confirm to execute small BNB conversion?",
    ConfirmPortfolioMarginRepay: "Confirm to execute margin repay?",
    ConfirmPortfolioContractAutoRepay:
      "Confirm to execute contract auto repay?",
    ConfirmPortfolioAutoCollect: "Confirm to execute auto collect?",

    OrderStatus: "Status",
    TimeInForce: "Validity",
    ImpactPercent: "IMP",
    EnableImpactPercent: "Enable IMP",
    EnableMarginAccount: "Enable Margin Account",
    EnableSpotAccount: "Enable Spot Account",
    OrderType: "Type",
    OrderQty: "Quantity",
    PositionSide: "Direction",
    TradeRate: "Filled",
    Action: "Action",
    OrderHistory: "Order History",
    PositionHistory: "Close History",
    AveragePositionCost: "Avg Position Cost",
    AverageClosePrice: "Avg Close Price",
    CloseAmount: "Close Amount",
    RealizedPnL: "Realized PNL(USD)",

    Position: "Position",
    Typenew: "Type",
    OpenPositions: "Open Positions",
    AverageOpenPrice: "Avg Open Price ",
    PositionValue: "Position Value",
    MarkPrice: "Mark Price",
    Margin: "Margin",
    MarginRatio: "Margin Ratio",
    UnrealizedPnL: "Unrealized PNL",
    ExchangePosition: "Exchange Position",
    ExchangeOpenOrder: "Exchange Pending Order",
    OpenOrder: "Pending Order",
    LiqPrice: "Liq. Price",
    Time: "Time",
    Type: "Type",
    CurrentTokensOnly: "Hide Other Coins",
    TriggerOrderLimit: "Trigger Order Limit",
    TriggerOrderMarket: "Trigger Order Market",
    BaseVersion: "Exclusive",
    ProVersion: "Pro",
    Details: "Details",
    Revoke: "Revoke",
    NineRounds: {
      Name: "Nine-Turn",
      NineRoundsA: {
        Name: "Nine-Turn A",
        TwoPointMethod: "Two-dot Method",
        ThreePointMethod: "Three-dot Method",
      },
      NineRoundsD: {
        D1Name: "Nine-Turn D1",
        D2Name: "Nine-Turn D2",
        SpaceMethod: "Space Method",
        TimeMethod: "Time Method",
      },
      Delete: "Delete",
      MessageText: {
        RenderError:
          "Unable to draw the Nine-Turn, please switch time or redraw.",
        Open: "Open",
        High: "High",
        Low: "Low",
        Close: "Close",
        Volume: "Volume",
        FirstPoint: "First Dot",
        SecondPoint: "Second Dot",
        ThirdPoint: "Third Dot",
        NewestPrice: "Last Price",
        RenderTipsClickTwo: "Click 2 dots.",
        RenderTipsClickThree: "Click 3 dots.",
        ConfirmRender: "Confirm to draw?",
        ConfirmReRender: "Confirm to redraw?",
        WillClear: "Clear Nine-Turn",
        Time: "Time",
        Price: "Price",
      },
    },
    Layout: {
      Name: "Layout",
      Lock: "Move Layout",
      AutoSave: "Auto Save",
      Rename: "Rename",
      NewLayout: "New Layout",
      MyLayout: "My Layout",
      RecoverDefault: "Restore Default",
      ConfirmDelete: "Confirm to delete the layout?",
      ConfirmDeleteTip: "Once deleted it cannot be restored.",
      Cancel: "Cancel",
      Confirm: "Confirm",
      SubMap: "Sub Map",
      BrowserNotSupport:
        "The current user's browser does not support Canvas, please change the browser and try again!",
      SaveSuccess: "Save Successful",
      SaveFail: "Save Failed",
      DeleteSuccess: "Delete Successful",
      DeleteFail: "Delete Failed",
    },
    RuleMessageTest: {
      NumRule: {
        IsNotNum: "Imput a number",
        IsIllegalNum: "Imput a valid number",
        IsNotNull: "Cannot be empty",
      },
      EmailRule: {
        IsIllegalEmail: "Please enter the correct email address",
        IsNotNull: "Email address cannot be empty",
      },
      PhoneRule: {
        IsNotNull: "Phone number cannot be empty",
        IsIllegalPhoneNumber: "Please enter a valid phone number",
      },
    },
    Deribit: {
      Position: "Position",
      OpenOrder: "Open Orders",
      OrderHistory: "Order History",
      PositionHistory: "Position History",
    },
  },
  views_login: {
    login: "Log In",
    login_input_userName_placeholder: "Email/Phone",
    login_input_correct_email: "Please enter the correct email",
    login_input_password_placeholder: "Password",
    login_input_VerificationCode_placeholder: "Verification Code",
    login_remember_password: "Remember password",
    login_forget_password: "Forgot password?",
    reset: "Reset",
    reset_password_success: "Reset Password Success",
    reset_password: "Reset Password",
    login_register: "Register",
  },
  client_things: {
    TotalVolume: "Total Volume",
    WeekVolume: "7d Volume",
    TotalMMVolume: "Total MM Volume",
    OrderQuantity: "Order Quantity",
    CommisionSaving: "Commision Saving",
    TotalRebate: "Total Rebate",
    TotalSaving: "Total Saving",
    TradeNow: "Trade Now",
    client_present: "Trade Easier",
    client_present_long: "Digital Assets Investment Management Platform",
    standard: "BTC spot has obtained SEC standard",
    standardMore: "More",
    WhyTradingX: "Why TradingX?",
    Executeinaggregation: "Efficient Aggregated Execution",
    Leadingmarketmakingtools: "Leading Market Making Tools",
    DataAnalysis: "Data Analysis",
    ComplianceSecurity: "Compliance&Security",
    Executeinaggregationnew:
      "Execute trading plans on major exchanges with a click on a single interface; reduce dealings with exchanges.",
    Leadingmarketmakingtoolsnew:
      "Fully auto trading bots and semi-auto tools help investors win in any market",
    DataAnalysisnew:
      "Analyse datas on the mainstream chains, trading datas of DEXes and CEXes, global stock market, foreign exchange market, gold and other trading datas. Help to optimize portfolios.",
    ComplianceSecuritynew:
      "Singapore and Hong Kong licenses, make trading more secure.",
    Announcement: "Announcement",
    UserGuide: "User Guide",
    ContactJoinUs: "Contact/Join Us",
  },
  components_myheader: {
    loginout: "Log Out",
    login: "Log In",
    register: "Register",
    totalone: "24h Volume",
    totaltwo: "24h AI Volume",
    totalthree: "24h Bot Volume",
    totalfour: "24h Rebate Amount",
    totalfive: "24h MM Volume",
    referral: "Referral",
    AllRead: "All Read",
    NoMore: "No More",
    TradeMessage: "Trade Message",
    Announcement: "Announcement",
    SystemMessage: "System Message",
    loadMore: "load More",
  },
  components_mysymbolselect: {
    search: "Search",
  },
  views_signup: {
    email: "Email",
    phone: "Phone",
    signup_input_userName: "Username",
    signup_input_userName_placeholder_email: "Email Address",
    signup_input_userName_placeholder_phone: "Phone Number",
    signup_input_userName_placeholder_Password: "Password",
    signup_input_userName_placeholder_confirmPassword: "Confirm your password",
    signup_input_userName_placeholder_inviteCode: "Referral code",
    signup_input_userName_placeholder_VerificationCode: "Verification Code",
    signup_input_userName_placeholder_Code: "Get a code",
    signup_register: "Register",
    signup_login: "Log in with registered account",
    signup_signup_success: "Registration Successful.",
    signup_email_phone: "Email/Telephone",
    signup_back_login: "Back to Log In",
    signup_please_input_password: "Imput the password",
    signup_please_input_size_password: "Imput a password of 8-20 digits",
    signup_please_input_confirm_password: "Confirm the Password",
  },
  user_info: {
    AccountManagement: "Account Management",
    Phone: "Phone",
    Level: "Level",
    Type: "Type",
    LoginLog: "Login Log",
    Add: "Add",
    Exchange: "Exchange",
    AccountName: "Account Name",
    APIKEY: "API Key",
    Secretkey: " Secret Key",
    ExpirationTime: "Expiration Time",
    PermissionList: "Permission List",
    IPList: "IP List",
    CreateTime: "Create Time",
    UpdateTime: "Update Time",
    Action: "Action",
    ViewBalance: "View Balance",
    Edit: "Edit",
    Delete: "Delete",

    AssetsManagement: "Assets Analysis",
    FinancialAnalysis: "Financial Analysis",

    StrategyAnalysis: "Strategy Analysis",
    SelectExchange: "Select Exchange",
    SelectStrategyType: "Select Strategy Type",
    SumQty: "Total Transaction Amount",
    TotalSumQty: "Cumulative Transaction Amount",
    SumCost24H: "24H Funding Cost",
    SumQty24H: "24H Transaction Amount",
    MaxHold24H: "24H Maximum Position",
    MaxHoldLong24H: "24H Maximum Position (Long)",
    MaxHoldShort24H: "24H Maximum Position (Short)",
    SumNetProfit24H: "24H Net Profit",
    SumUnrealizedProfit24H: "24H Unrealized Profit",
    SumTotalProfit24H: "24H Total Profit",
    ProfitAndMaxDrawDownChart: "Profit and Maximum Drawdown",
    NetProfitRate24H: "24H Rate of Return",
    SumNetProfitRate: "Cumulative Rate of Return",
    LowWater: "Low Water Level",
    MaxDrawDown24H: "24H Maximum Drawdown",

    NetValueChart: "Compound rate of return",
    DrawDownChart: "Drawdown",
    ProfitChart: "Profit",
    NetValue: "Net Asset Value",
    HighWater: "High Water",
    DrawDown: "Drawdown",
    Profit: "Profit",
    TotalProfit: "Cumulative profit",

    Date: "Time",
    Return: "Yield",
    TotalReturn: "Cumulative Yield",
    GrossReturn: "Gross Yield",
    Nav: "Nav",
    Balance: "Balance",
    Transfer: "Transfer",
    LastUpdateTime: "Last update time",

    AnnualReturn: "Annualized rate of return",
    AnnualVolatility: "Annualized Volatility",
    SharpeRatio: "Sharpe Ratio",
    MaxDrawDown: "Maximum drawdown",

    Hour: "hour",
    Day: "Day",
    Week: "week",
    Month: "month",
    Year: "year",
    TIME_7D: "7 days",
    TIME_30D: "30 days",
    TIME_90D: "90 days",
    TIME_180D: "half a year",
    TIME_365D: "One year",
    OTHER: "Custom",

    AllAccount: "All Account",
    AllSourceAsset: "All Source",
    SelectAccountType: "Select account type",
    SelectSourceAsset: "Select source asset",
    SelectTimeRange: "Select time range",
    SelectTimeDuration: "Select time interval",
    SelectSubAccount: "Select subaccount",
    SelectStatisticsCurrency: "Select statistical currency",

    LastDayPnL: "24h PNL",
    LastWeekPnL: "7 days PNL",
    LastMonthPnL: "30 days PNL",
    Chart: "Chart",
    DailyPnL: "Daily PNL",
    CumulativePnL: "Cumulative PNL",
    PnLDistribution: "PNL Allocation",
    Smart: "AI Trade",
    Bots: "Bots",
    AssetsDistribution: "Assets Allocation",
    PositionDistribution: "Position Allocation",

    Traders: "Traders",
    Observer: "Observer",
    Risk: "Risk Account",
    ToVerify: "Verify Now",
    ConfirmDelete: "Confirm deletion？",
    ConfirmDeleteTips: "This action cannot be undone！",
    Confirm: "Confirm",
    Cancel: "Cancel",

    AccountBalance: "Account Balance",
    Currency: "Coin",

    AccountType: "Type",
    AvailableBalance: "Avl.Balance",
    LockBalance: "Lock Balance",
    MarginBalance: "Margin Balance",
    WalletBalance: "Wallet Balance",
    MaxTransferableBalance: "Max Transferable Balance",
    Total: "Total",
    Record: "Records",

    Account: "Account",
    LoginIP: "Login IP",
    LoginTime: "Login Time",

    ApiKey: {
      ApiForm: {
        NewAccount: "New Account",
        EditAccount: "Edit Account",
        AccountName: "Account Name",
        Exchange: "Exchange",
        AccountApiKey: "API Key",
        AccountSecretKey: "Secret Key",
        AccountPassPhrase: "Passphrase",
        AuthList: "Auth List",
        SpotTrade: "Spot",
        FutureTrade: "Future",
        Reset: "Reset",
        Rule: {
          NameMsg: "Account Name",
          ExchangeMsg: "Exchange",
          ApiKeyMsg: "Api Key",
          SecretKeyMsg: "Secret Key",
          PassPhraseMsg: "Passphrase",
          AuthListMsg: "Select Permissions",
          FuturesmktPwdMd5Invalid: "Must be 32-char lowercase hex MD5",
        },
        Confirm: "Confirm",
        Cancel: "Cancel",
        Futuresmkt: {
          AccountNo: "Account No.",
          PwdMd5: "Login Password MD5",
          OrgCode: "Org Code",
          OrgCodeOptional: "Optional, e.g. trade",
        },
      },
    },
  },
  data_info: {
    Data: "Data",
    Greedindex: "Greed index",
  },
  setting_info: {
    Navigator: "Navigator",
    System: "System Settings",
    Language: "Language",
    Currency: "Currency",
    TimeZone: "Time Zone",
    Notice: "Notice",
    Trade: "Trade",
    OpenTradeNotice: "Open Trade Notice",
    Announcement: "Announcement",
    OpenAnnouncementNotice: "Open Announcement Notice",
    ON: "ON",
    OFF: "OFF",
    Security: "Security",
    BindEmail: "Bind Email",
    BindedEmai: "Binded Email",
    SMSVerification: "SMS Verification",
    EffectivelyProtectAccountSecurity: "Effectively Protect Account Security",
    EmailVerification: "Email Verification",
    EffectivelyProtectEmailSecurity: "Effectively Protect Email Security",
    BindIP: "Bind IP",
    BindedIP: "Binded IP",
    Change: "Change",
    ChangePassword: "Change Password",
    LanguageSetting: {
      SimplifiedChinese: "简体中文",
      TraditionalChinese: "繁體中文",
      English: "English",
    },
    SecuritySetting: {
      AccountPassword: "Account Password",
      PasswordLevel: "Password Level",
      PasswordLevelLow: "Low",
      PasswordLevelMedium: "Medium",
      PasswordLevelHigh: "High",
    },
    PlaceHolderText: {
      OldPassword: "Old Password",
      NewPassword: "New Password",
      ConfirmPassword: "Confirm Password",
    },
  },
  PlaceHolderText: {
    Cancel: "Cancel",
    Confirm: "Confirm",
  },

  Dictionary: {
    EXECUTING: "Executing",
    EXECUTED: "Executed",
    CANCELING: "Canceling",
    CANCELED: "Canceled",
    EXECUTION_ERROR: "Execution Error",
    OPEN: "Open",
    CLOSE: "Close",
    BUY: "Buy",
    SELL: "Sell",
    LONG: "Long",
    SHORT: "Short",
    BOTH: "Both",
    NORMAL_MODE: "Normal Mode",
    FILLED: "Filled",
    LIMIT: "Limit",
    MARKET: "Market",
    STOP_MARKET: "Stop Loss Market",
    TAKE_PROFIT_MARKET: "Take Profit Market",
    TAKE_PROFIT: "Take Profit",
    STOP_LOSS: "Stop Loss",
    PARTIALLY_FILLED: "Partially Filled",
    TRADING: "Trading",
    DIRECT_MODE: "Direct Mode",
    BINANCE_FUNDING: "Funds",
    BINANCE_SPOT: "Spot",
    BINANCE_MARGIN_CROSSED: "Full Margin",
    BINANCE_MARGIN_ISOLATED: "Isolated Margin",
    BINANCE_FUTURE: "USDⓈ-M Futures",
    BINANCE_SWAP: "Coin-M Futures",
    SPOT: "Spot",
    SWAP: "Coin-M Futures",
    FUTURE: "USDⓈ-M Futures",
    LINEAR: "USD Contract",
    INVERSE: "Inverse Contract",
    spot: "Spot",
    swap: "Perpetual Contract",
    linear: "USD Contract",
    inverse: "Inverse Contract",
    OKX_SPOT: "Spot",
    OKX_MARGIN: "Margin",
    OKX_SWAP: "Perpetual Contract",
    OKX_FUTURES: "Delivery Contract",
    OPTION: "Option",
    INDEX: "Index",
    FUTURES: "Futures",
    FOREX: "Forex",
    ASTOCK: "A Stock",
    EXECUTION_TIMEOUT: "Execution Timeout",
    UNFILLED: "Unfilled",
    CONDITIONAL: "Conditinal",
    OCO: "OCO",
    CONDITIONAL_OCO: "Conditional/OCO",
    TRIGGER_ORDER_LIMIT: "Trigger Limit",
    TRIGGER_ORDER_MARKET: "Trigger Market",
    TP_TRIGGER_PRICE: "TP Trigger Price",
    TP_ORDER_PRICE: "TP Order Price",
    TP_LIMIT: "TP Limit",
    TP_MARKET: "TP Market",
    SL_TRIGGER_PRICE: "SL Trigger Price",
    SL_ORDER_PRICE: "SL Order Price",
    SL_LIMIT: "SL Limit",
    SL_MARKET: "SL Market",
    WAITING: "Waiting",
    EXPIRED: "Expired",
    PLACE_ORDER: "Maker",
    FAILURE: "Failure",
    PREPARING: "Preparing",
    STOPPED: "Stopped",
    STOPPING: "Stopping",
    BACKTEST_FINISHED: "Backtest finished",
    TRADING_HALTED: "Trading halted",
    SELL_CLOSE: "Sell Close",
    SELL_OPEN: "Sell Open",
    BUY_CLOSE: "Buy Close",
    BUY_OPEN: "Buy Open",
    CLOSE_LONG: "Close Long",
    CLOSE_SHORT: "Close Short",
    INTERRUPTED: "Interrupted",

    UNIFIED: "UNIFIED",
    CONTRACT: "CONTRACT",

    SAT_BINANCE_SPOT: "Spot",
    SAT_BINANCE_MARGIN_CROSSED: "Cross Margin",
    SAT_BINANCE_MARGIN_ISOLATED: "Isolated Margin",
    SAT_BINANCE_FUTURE: "USDⓈ-M",
    SAT_BINANCE_SWAP: "Coin-M",
    SAT_OKX_SPOT: "Spot",
    SAT_OKX_SWAP: "Perpetual",
    SAT_OKX_FUTURES: "Delivery",
    SAT_BYBIT_spot: "Spot",
    SAT_BYBIT_linear: "USDⓈ-M",
    SAT_BYBIT_inverse: "Inverse",

    SAT_GATE_spot: "Spot",
    SAT_GATE_futures: "Perpetual",
    SAT_GATE_delivery: "Delivery",

    SAT_ASTER_SPOT: "Spot",
    SAT_ASTER_FUTURE: "USDⓈ-M",

    AAT_BINANCE_FUNDING: "Funding",
    AAT_BINANCE_SPOT: "Spot",
    AAT_BINANCE_MARGIN_CROSSED: "Cross Margin",
    AAT_BINANCE_MARGIN_ISOLATED: "Isolated Margin",
    AAT_BINANCE_FUTURE: "USDⓈ-M",
    AAT_BINANCE_SWAP: "Coin-M",
    AAT_BINANCE_PORTFOLIO_MARGIN: "Unified",
    AAT_OKX_FUNDING: "Funding",
    AAT_OKX_SPOT: "Unified",
    AAT_BYBIT_FUNDING: "Funding",
    AAT_BYBIT_UNIFIED: "Unified",
    AAT_BYBIT_CONTRACT: "Contract",

    AAT_GATE_spot: "Spot",
    AAT_GATE_futures: "Perpetual",
    AAT_GATE_delivery: "Delivery",
    AAT_GATE_unified: "Unified",
    AAT_GATE_margin: "Isolated Margin",
    AAT_GATE_cross_margin: "Cross Margin",

    AAT_ASTER_SPOT: "Spot",
    AAT_ASTER_FUTURE: "USDⓈ-M",

    SUNX_swap: "Perpetual",
    SUNX_SWAP: "Perpetual",
    SAT_SUNX_SWAP: "Perpetual",
    AAT_SUNX_SWAP: "Perpetual",

    FUTURESMKT_UNIFIED: "Futures Unified Account",
    FUTURESMKT_CBOT: "CBOT",
    FUTURESMKT_CME: "CME",
    FUTURESMKT_COMEX: "COMEX",
    FUTURESMKT_EUREX: "EUREX",
    FUTURESMKT_HKEX: "HKEX",
    FUTURESMKT_NYMEX: "NYMEX",
    FUTURESMKT_SGX: "SGX",

    XCOIN_spot: "Spot",
    XCOIN_linear_perpetual: "Linear Perpetual",
    XCOIN_linear_futures: "Linear Futures",

    BITGET_SPOT: "Spot",
    BITGET_MARGIN_CROSSED: "Crossed Margin",
    BITGET_MARGIN_ISOLATED: "Isolated Margin",
    "BITGET_USDT-FUTURES": "USDT Perpetual",
    "BITGET_COIN-FUTURES": "Coin Perpetual",
  },
  Modal: {
    EmptyModal: {
      Message: "No Data",
    },
    InviteModal: {
      Invite: "Invite",
      Cancel: "Cancel",
      RateOfReturn: "Yield",
      InviteCode: "Referral Code",
      Copy: "Copy",
      JoinCryptoJourney: "Invite friends and share strategy trading!",
      ShareLink: "Share Link",
      ShareOn: "Share on",
      NoInviteCode: "Invite code not found",
      InviteCodeCopied: "Referral code copied",
      InviteLinkCopied: "Invite link copied",
      CopyFailed: "Copy failed, please try again",
      ScanQRCode: "Please scan QR code with WeChat",
      ShareText: "I'm using TradingX for cryptocurrency trading, come join me!",
      Loading: "Loading...",
    },

    DeribitModal: {
      Cancel: "Cancel",
      Call: "Long",
      Put: "Short",
      Amount: "Amount",
      Position: "Position",
      LimitPrice: "Limit Price",
      AdvancedOrderForm: "Advanced Order",
      TimeInForce: "TIF",
      Reduce: "Reduce",
      Post: "Post",
      BuyMargin: "Buy Margin",
      SellMargin: "Sell Margin",
      ContractDetails: "Contract Details",
      PriceSource: "Price Source",
      ContractSize: "Contract Size",
      MinOrderSize: "Min Order Size",
      TickSize: "Tick Size",
      SettlementCurrency: "Settlement Currency",
      ExpiryDate: "Expiry Date",
      MinSellPrice: "Min Sell Price",
      MaxBuyPrice: "Max Buy Price",
      Delta: "Delta",
      Gamma: "Gamma",
      Vega: "Vega",
      Theta: "Theta",
      Rho: "Rho",
      OrderBook: "Order Book",
      MarkPrice: "Mark Price",
      the24hLow: "24h Low",
      the24hHigh: "24h High",
      the24hVolume: "24h Volume",
      the24hChange: "24h Change",
      Total: "Total",
      Sum: "Total",
      AvgPrice: "Avg Price",
      BidSize: "Bid Size",
      BidPrice: "Bid Price",
      AskPrice: "Ask Price",
      AskSize: "Ask Size",
      RecentTrade: "Last Trades",
      Chart: "Chart",
      Buy: "Buy",
      Sell: "Sell",
      RecentSevenDays: "Recent 7 Days",
      RecentOneMonth: "Recent 1 Month",
      RecentThreeMonths: "Recent 3 Months",
      AllTime: "All Time",
    },
    WarningModal: {
      PriceAlert: "Price Alert",
      Monitoring: "Monitoring",
      MonitoringRecord: "Monitoring Record",
      NewAlert: "New Alert",
      Cancel: "Cancel",
      PriceAlertSettings: "Price Alert Settings",
      Save: "Save",
      Load: "Load",
      TransactionType: "Trade Type",
      PleaseSelect: "Please Select",
      NewestPrice: "Last Price",
      TriggerPrice: "Trigger Price",
      DownTo: "Down to",
      UpTo: "Up to",
      RangePrice: "Price Range",
      Amplitude: "Amplitude",
      WarningDuration: "Alert Duration",
      Alert: "Alert",
      ExpirationTime: "Expiration Time",
      OneMinute: "1 Minute",
      CloseManually: "Close Manually",
      WebSide: "Web Side",
      AppSide: "App Side",
      TriggeringConditions: "Trigger Conditions",
      PriceAtSetup: "Price At Setup",
      CreatedOrExpired: "Created/Expired",
      Status: "Status",
      Action: "Action",
      EffectiveTime: "Effective Time",
    },
    LeverModal: {
      LevelTransfer: "Leverage Transfer",
      Transfer: "Transfer",
      Cancel: "Cancel",
      From: "From",
      To: "To",
      Currency: "Coin",
      AvailableFunds: "Available Funds",
      TransferAmount: "Transfer Amount",
      All: "All",
      IsolateAccount: "Isolated",
      FullAccount: "Cross",
      SpotAccount: "Spot",
    },
    AIModal: {
      Spot: "Spot",
      Isolate: "Isolated",
      Full: "Cross",
      BrrowAndRepay: "Brrow/Repay",
      PleaseLogin: "Please Login！",
    },
    CiculateModal: {
      Spot: "Spot",
      Isolate: "Isolated",
      Full: "Cross",
      MarginBrrowAndRepay: "Margin Brrow/Repay",
      Confirm: "Confirm",
      Cancel: "Cancel",
      LoanAmount: "Loan Amount",
      CurrentlyAvailableToBorrowTips:
        "Max borrowable amount in the user account under sufficient available fund",
      CurrentlyAvailableToBorrow: "Currently available to borrow",
      MaxAvailableToBorrowTips:
        "Max borrowable amount for the current level as per platform limitations",
      MaxAvailableToBorrow: "Max Borrowable",
      HourlyInterestRate: "Hourly Interest Rate",
      HourlyInterestRateTips:
        "When borrowing assets, interest will immediately accrue for one hour, and interest will be calculated once per hour (less than one hour is calculated as one hour)",
      Loan: "Loan",
      Repay: "Repay",
      Available: "Available",
      Borrowed: "Borrowed",
      NetAssets: "Net Assets",
      CurrentInterest: "Current Interest",
      RepaymentAmount: "Repayment Amount",
      MaximumRepayable: "Max Repayable",
      OperationSuccessful: "Action Successful",
      OperationFailed: "Action Failed",
    },
    LeverageToolsModal: {
      Isolate: "Isolate",
      Full: "Cross",
      MarginModel: "Margin Mode",
      Confirm: "Confirm",
      MarginModelTips1:
        "Adjusting margin mode only applies to the current contract.)",
      FullMarginTipsTitle: "Cross Margin Mode:",
      FullMarginTipsContent:
        "Positions with the same margin assets in full margin mode share the full margin of that asset. During liquidation events, traders may lose the entire margin and all full margin positions associated with that margin asset.",
      IsolateMarginTipsTitle: "Isolated Margin Mode:",
      IsolateMarginTipsContent:
        "A certain amount of margin is allocated to each position. If the position's margin falls below the maintenance margin level, the position will be liquidated. In isolate mode, you can add or reduce margin for this position.",
      Cancel: "Cancel",
      LeverageSetting: "Leverage Setting",
      CurrentLeveragePosition: "Max",
      CurrentLeveragePositionTips1:
        "The leverage adjustment will affect both the current position and the leverage of Maker.",
      CurrentLeveragePositionTips2:
        "Trading with leverage exceeding [10x] increases the risk of forced liquidation. Please be aware of the associated risks.",
      ModelSetting: "Model Setting",
      PositionModel: "Position Mode",
      OneWayPosition: "One-way Mode",
      OneWayPositionTips:
        "In One-way Mode, a symbol only supports holding a position in one direction.",
      TwoWayPosition: "Hedge Mode",
      TwoWayPositionTips:
        "In Hedge Mode, a symbol supports simultaneously holding long position and short position, and unrealized PNL can be offset between two positions of the symbol.",
      AssetModel: "Asset Model",
      SingleModel: "Single-Asset Mode",
      SingleModelTips1:
        "Supports USDⓈ-M Futures trading by only using the single asset of the symbol.",
      SingleModelTips2: "PNL of the same margin asset positions can be offset.",
      SingleModelTips3: "Supports Cross Margin Mode and Isolated Margin Mode.",
      CombineModel: "Multi-Assets Mode",
      CombineModelTips1:
        "USDⓈ-M Futures trading across multiple margin assets.",
      CombineModelTips2:
        "PNL can be offset among the different margin asset positions.",
      CombineModelTips3: "Only supports Cross Margin Mode",
      PleaseSelectApi: "Please Set Api",
      ActionSuccessful: "Action Successful",
      ActionFailed: "Action Failed",
    },
    UserCountModal: {
      SelectSubAccount: "Sub Account",
      Save: "Save",
      Cancel: "Cancel",
      SelectExchange: "Exchange",
      All: "All",
      Main: "Main",
      Ratio: "Ratio",
      MaxQty: "Max Amount",
      MaxQtyTips: "Imput the Max Avbl amount",
      SyncRatio: "Sync Ratio",
      AvailableBalance: "Avbl Balance",
      WalletBalance: "Wallet Balance",
      ErrMsg: "Incorrect API key, please check the account settings!",
    },
    TransferModal: {
      UniversalTransfer: "Universal Transfer",
      Transfer: "Transfer",
      AssetTransfer: "Fund transfer",
      TransferHistory: "Transfer record",
      Cancel: "Cancel",
      AccountSelect: "Account",
      From: "From",
      To: "To",
      Currency: "Coin",
      AvailableFunds: "Avbl Funds",
      TransferAmount: "Transfer Amount",
      All: "All",
      SpotAccount: "Spot",
      FutureAccount: "USDⓈ-M Futures",
      SwapAccount: "COIN-M Futures",
      FundsAccount: "Funding",
    },
  },

  AIDashboard: {
    AIDashboardDetail: {
      Group: "Transaction Group",
      Export: "Export",
      Search: "Search",
      Optional: "Mine",
      Market: "Market",
      Symbol: "Symbols",
      Sort: "Rank",
      Price: "Price",
      UpDown: "24h %",
      TREND: "Trend Tools",
      STRONG_BACK: "Buy Low Sell High",
      SHOCK_GRID: "Grid",
      ARB_SPREAD: "Arb Spread",
      ARB_STAT: "Arb Stat",
      SMART_EXECUTE: "Execution",
      ARB_FUNDING: "Smart Funding Arbitrage",
      SMART_SHOCK_GRID: "AI Grid",
      SHOCK_REVERSE: "Buy Low Sell High",
      RATE_GRID: "Rate Grid",
      STRONG_GRID: "Strong Grid",
      TER: "Trend Continuation",
      TerMode: "Risk mode",
      TerModeBalance: "Balanced",
      TerModeAggressive: "Aggressive",
      TerMakerOnly: "Maker only",
      TerMaxTradeQty: "Available amount",
      TerBalance: "Balance",
      TerEquity: "Equity",
      TerSymbolHint:
        "Only Binance USD-M XAUUSDT and OKX swap XAU-USDT-SWAP are supported, and the account must be cross margin. Other symbols are rejected by the strategy.",
      VOLUME_LATTICE: "Volume Lattice",
      VolumeLatticeMaxTradeQty: "Available amount",
      VolumeLatticeInitialQty: "Initial size",
      VolumeLatticeBalance: "Balance",
      VolumeLatticeEquity: "Equity",
      VolumeLatticeSymbolHint:
        "Only Binance USD-M XAUUSDT and OKX swap XAU-USDT-SWAP are supported. The account must be hedge mode, cross margin on both sides, and flat on this symbol. Initial size is the XAU base-coin quantity, not the number of contracts. Grid distance, stop, take-profit, and profit lock are fixed in the strategy. The strategy service rejects anything else.",
      MARKETMAKER: "Market Maker",
      RL_MARKETMAKER: "Enhanced Market Maker",
      MmTargetSingle: "Single Symbol",
      MmTargetPair: "Pair Universe",
      MmPairNotSelectedMsg: "Please select a pair first",
      MmPairResolveFailedMsg: "Failed to resolve pair contracts",
      MmPairNotFoundMsg: "Pair not found; switched to single symbol",
      ARB_OPTION: "Option Arbitrage",
      ARB_FACTOR: "Statistical Arbitrage",
      ASTOCK_EXECUTE_MULTI: "A Stock Execute",
      SOR: "Smart Execution",
      SOR_DIRECT: "Forward Arbitrage",
      SOR_INVERSE: "Inverse Arbitrage",
      SOR_DELIVERY: "Delivery Arbitrage",
      SOR_ARB: "Funding Arbitrage",
      TREND_CONTINUE_ROBOT: "Second Wave Of Trend",
      MarkPrice: "Mark Price",

      The24hHigh: "24h High",
      The24hLow: "24h Low",
      The24hVolume: "24h Volume",
      The24hQty: "24h Amount",
      SelectEnvironment: "Environment",
      TestEnvironment: "Test",
      ProductionEnvironment: "Production",
      AwsEnvironment: "AWS",
      LinodeEnvironment: "Linode",
      Linode2Environment: "Linode2",
      Local211Environment: "Local211",
      SelectSubAccount: "Sub Account",
      PleaseCancelUpdate: "Please cancel update",
      UnknownStrategyMsg: "Unknown Strategy",
      StartSuccessfulMsg: "Start Successful",
      StartFailedMsg: "Start Failed",
      UpdateSuccessfulMsg: "Updated",
      UpdateFailedMsg: "Update Failed",
      UnknownSymbolMsg: "Unknown Pair",
      GetSubscribeListFailed: "Subscription list retrieval failed",
      Number: "Number",
      Unfold: "Unfold",
      BatchDelete: "Batch Delete",
      ClearSelected: "Clear Selected",
    },
    KChart: {
      HistoryMarks: "Order History",
      CurrentMarks: "Open Orders",
    },
    Form: {
      MaxOrderAmount: "Maximum Qty",
      MinOpenSpread: "Min Open Spread",
      MinCloseSpread: "Min Close Spread",
      ImpactLevel: "Level",
      ImpactMultiple: "Multiple(x)",
      ImpactNumPerMinute: "IMP/Min",
      Auto: "AI",
      Manual: "Manual",
      Level: "Level",
      LevelSetting: "Order Settings",
      LevelStart: "Start Position",
      LevelTotal: "Pending orders",
      LevelInterval: "Price Interval",
      PositionSetting: "Position Setting",
      ArbStatFuturesMarketSizingMode: "Hedge mode",
      ArbStatFuturesMarketSizingModeNotionalFirst: "No restriction",
      ArbStatFuturesMarketSizingModeDiscreteNeutral: "Reject if not hedged",
      ArbStatFuturesMarketMaxLotSkewRatio: "Max single-leg exposure skew",
      ArbStatFuturesMarketMaxLotSkewRatioInvalid:
        "Max single-leg exposure skew must be a valid percentage ≥ 0.",
      MultiplePositionsAvailable: "Avbl Long Position",
      ShortPositionAvailable: "Avbl Short Position",
      TargetPosition: "Target",
      AmountAvailable: "Avbl Amount",
      AllAmountAvailable: "Total Avbl Amount",
      AvailableAmountOnce: "Avbl Once",
      RobotN: "Only Trade The Top N Liquidity",
      PitchRatio: "Range Ratio",
      OrderStep: "Split Order Spacing",
      OrderQuantity: "Amount",
      Isolate: "Isolated",
      Cross: "Cross",
      Spot: "Spot",
      Available: "Available",
      Borrowed: "Borrowed",
      IsolatedMarginNetAssets: "Isolated Net Assets",
      CrossMarginNetAssets: "Cross Net Assets",
      SpotNetAssets: "Spot Balance",
      CanBeOpened: "Max",
      Balance: "Balance",
      CustomInstanceName: "Custom Instance Name",
      Reset: "Reset",
      Cancel: "Cancel",
      NotLoggedIn: "Not Logged In",
      InsufficientVipLevel: "Locked",
      Startup: "Start",
      Update: "Update",
      SmartPrice: "SPF",
      Gear: "Gear",
      Window: "Window",
      Cycle: "Period",
      LongCycle: "Long Period",
      ShortCycle: "Short Period",
      PriceGap: "Price Range",
      Minimum: "Min",
      Maximum: "Max",
      Volatility: "Volatility",
      Trend: "Trend",
      OrderBook: "OIF",
      OFIF: "OFIF",
      MaximumInventory: "Max Inventory",
      EnableCombination: "Enable Combination",
      EnableTimeSharing: "Enable Timeline",
      EnableHedge: "Enable Hedge",
      ExecMode: "Execution Mode",
      ExecModeLive: "Live",
      ExecModeSim: "Simulation",

      EnableLiquidation: "Enable Liquidation",
      LiquidationRatio: "Liquidation Ratio",
      Clearance: "Close",
      AllClearance: "Close All",
      OnlyMaker: "Only Maker",
      IsReplay: "Replay Mode",
      ReplayStartTime: "Replay Start Time",
      ReplayEndTime: "Replay End Time",
      ReplaySpeed: "Replay speed",
      ArbStatManualParamsSection: "cointegration parameters",
      ArbStatSectionSignalOpenConfirm: "Signal periods and open confirmation",
      ArbStatSectionCopula: "Copula entry and exit thresholds",
      ArbStatSectionCointPnl: "Coint position, dynamic TP/SL and time limit",
      ArbStatSectionRunReplay: "Execution, replay and instance",
      ArbStatTwapUse: "Use TWAP (maker slices)",
      ArbStatTwapWindowSec: "TWAP window",
      ArbStatTwapSliceCount: "TWAP slices",
      ArbStatTwapMakerPlacementMode: "Maker placement mode",
      ArbStatTwapMakerPlacementModeSingle: "Single level",
      ArbStatTwapMakerPlacementModeMultiLevel: "Top N levels",
      ArbStatTwapMakerPlacementModeAdaptive: "Adaptive",
      ArbStatTwapMakerDepthLevels: "Depth levels",
      ArbStatTwapNotionalBoundsEnabled: "Enable notional bounds",
      ArbStatTwapSliceMinNotional: "Min slice notional",
      ArbStatTwapSliceMaxNotional: "Max slice notional",
      ArbStatTwapOrderMinNotional: "Min order notional",
      ArbStatTwapOrderMaxNotional: "Max order notional",
      ArbStatTwapOrderMaxNotionalJitterMinRatio:
        "Order max notional jitter min ratio",
      ArbStatTwapAdaptiveNotionalMultEnabled: "Enable adaptive notional mult",
      ArbStatTwapAdaptiveNotionalMultMax: "Adaptive notional mult max",
      ArbStatSimFillMode: "Simulated fill mode",
      ArbStatSimFillModeQueue: "Queue model",
      ArbStatSimFillModeTradeCross: "Trade cross model",
      ArbStatMaxMakerFeeRate: "Maker fee rate cap",
      ArbStatMaxMakerFeeRateHint:
        "No new positions while the live maker fee rate is above this cap.",
      ArbStatTwapParamsInvalid:
        "TWAP: window must be at least 1s; slice count must be an integer ≥ 1; top N levels mode requires depth 2–5; with notional bounds on, each value must be positive and min < max.",
      SecondsUnit: "s",
      ArbStatSubpanelDynamicPnl: "Dynamic TP/SL parameters",
      ArbStatPeriods: "Signal periods",
      ArbStatCopulaMinConfirmPeriods: "Min confirm periods",
      ArbStatConfirmPeriodSetWhitelist: "Allowed confirm period sets",
      ArbStatConfirmPeriodSetHint:
        "Leave empty for no restriction. One combination per row; order is normalized to match signal periods on submit.",
      ArbStatConfirmPeriodSetAdd: "Add set",
      ArbStatConfirmPeriodSetRemove: "Remove",
      ArbStatConfirmPeriodSetTooFew:
        "Each whitelist row needs at least {min} periods.",
      ArbStatConfirmPeriodWhitelistSwitch: "Enable period-set whitelist",
      ArbStatConfirmPeriodComboAdd: "Add",
      ArbStatConfirmPeriodWhitelistNeedOne:
        "With whitelist enabled, add at least one set or turn the switch off.",
      ArbStatConfirmPeriodComboDuplicate: "This combination is already added.",
      ArbStatConfirmPeriodComboNeedSelect: "Select periods in the box first.",
      ArbStatExcludePairsWhitelist: "Excluded pair combinations",
      ArbStatExcludePairsHint:
        "Select pair combinations to temporarily exclude from arb entry.",
      ArbStatExcludePairsWhitelistSwitch: "Enable pair exclusion",
      ArbStatExcludePairsComboAdd: "Add",
      ArbStatExcludePairsComboDuplicate: "This pair is already added.",
      ArbStatExcludePairsComboNeedSelect: "Select a pair in the box first.",
      ArbStatSymbolsNeedThree:
        "Exactly 3 symbols are required, matching the sidebar pool.",
      ArbStatSymbolsNeedTwo: "At least 2 symbols are required.",
      ArbStatNeedTradablePair:
        "Need at least one tradable pair whose both legs have a non-zero API.",
      ArbStatApiSetting: "API Settings",
      ArbStatNoTradeAccount: "Do not trade (Copula only)",
      ArbStatBitgetHint:
        "Bitget Classic hedge only. Account type must be USDT-FUTURES; UTA init will fail.",
      ArbStatLegacyInstanceHint:
        "This instance uses the old param shape. Stop it, then Start to create a new instance. Hot-update is not allowed.",
      ArbStatMemberKeyInvalid: "Cannot parse pair identity. Pick another pair.",
      ArbStatCopulaEntryThreshold: "Entry level",
      ArbStatCopulaMinRho: "Min correlation",
      ArbStatDynThresholdK: "Dynamic threshold K",
      ArbStatDynThresholdBlend: "Dynamic threshold blend",
      ArbStatCopulaExitThreshold: "Exit / mean-reversion threshold",
      ArbStatCopulaRevertMinProfitEnabled:
        "Require min profit for copula revert close",
      ArbStatCopulaRevertMinProfitFrac: "Revert min-profit fraction",
      ArbStatCopulaRevertMinProfitParamsInvalid:
        "Revert min-profit fraction must be in [0, 1] (0 allowed).",
      ArbStatRhoDropThreshold: "Correlation drop ratio",
      ArbStatCopulaEntryPullbackFrac: "Signal pullback ratio",
      ArbStatCopulaEntryPullbackMinPoints: "Min data points for pullback",
      ArbStatCopulaEntryPullbackPeakMinAge: "Peak gate slots",
      ArbStatCopulaEntryEwmaSlopeLagSlots: "EWMA slope lag slots",
      ArbStatCopulaReopenAfterLossNeedNeutral:
        "Require neutral copula to reopen after stop loss",
      ArbStatCopulaEntryKlineFactorFilters: "Entry K-line factor filters",
      ArbStatCopulaEntryKlineFactorFiltersHint:
        "Empty list disables filters. Multiple rules are AND-ed in order; each rule is one period and factor type.",
      ArbStatCopulaEntryKlineFilterItemTitle: "Rule {index}",
      ArbStatCopulaEntryKlineFilterAdd: "Add rule",
      ArbStatCopulaEntryKlineFilterRemove: "Remove",
      ArbStatCopulaEntryKlineFilterFactorType: "Factor type",
      ArbStatCopulaEntryKlineFilterFactorType_sma: "SMA",
      ArbStatCopulaEntryKlineFilterFactorType_ema: "EMA",
      ArbStatCopulaEntryKlineFilterFactorType_wma: "WMA",
      ArbStatCopulaEntryKlineFilterFactorType_vwma: "VWMA",
      ArbStatCopulaEntryKlineFilterFactorType_cci: "CCI",
      ArbStatCopulaEntryKlineFilterFactorType_rsi: "RSI",
      ArbStatCopulaEntryKlineFilterFactorType_natr_expand:
        "ATR Expand / natr_expand",
      ArbStatCopulaEntryKlineFilterFactorType_ma_cross: "MA Cross",
      ArbStatCopulaEntryKlineFilterFactorType_stoch_rsi: "Stoch RSI",
      ArbStatCopulaEntryKlineFilterStochHint:
        "K/D is computed on closed ratio bars. Overbought allows only a short ratio; oversold allows only a long ratio. At most one rule.",
      ArbStatCopulaEntryKlineFilterStochRsiLength: "RSI length",
      ArbStatCopulaEntryKlineFilterStochLength: "Stoch length",
      ArbStatCopulaEntryKlineFilterStochSmoothK: "Smooth K",
      ArbStatCopulaEntryKlineFilterStochSmoothD: "Smooth D",
      ArbStatCopulaEntryKlineFilterStochExitHint:
        "Always saved and validated. They close a position only when independent exit or signal exit is selected. Exit cross only adds a K/D check and does not enable the close.",
      ArbStatCopulaEntryKlineFilterStochExitShort: "Short reversal K below",
      ArbStatCopulaEntryKlineFilterStochExitLong: "Long reversal K above",
      ArbStatCopulaEntryKlineFilterStochInvalid:
        "Invalid Stoch RSI lengths: RSI and Stoch must be integers in 2–500, Smooth K/D integers in 1–50, and 0 is not allowed",
      ArbStatCopulaEntryKlineFilterStochRangeInvalid:
        "Invalid Stoch RSI thresholds: require 0 ≤ low < high ≤ 100, short-exit K < high, long-exit K > low, and short-exit K < long-exit K",
      ArbStatCopulaEntryKlineFilterStochDuplicate:
        "At most one Stoch RSI filter",
      ArbStatCopulaEntryKlineFilterMaCrossFastType: "Fast MA type",
      ArbStatCopulaEntryKlineFilterMaCrossFastLength: "Fast MA period",
      ArbStatCopulaEntryKlineFilterMaCrossSlowType: "Slow MA type",
      ArbStatCopulaEntryKlineFilterMaCrossSlowLength: "Slow MA period",
      ArbStatCopulaEntryKlineFilterMaCrossInvalid:
        "Invalid MA Cross config: fast/slow MA types must be sma/ema/wma/vwma, fast period >= 2, slow period >= 2",
      ArbStatCopulaEntryKlineFilterPeriod: "K-line period",
      ArbStatCopulaEntryKlineFilterLengths: "MA lengths",
      ArbStatCopulaEntryKlineFilterLengthItem: "Length {index}",
      ArbStatCopulaEntryKlineFilterLengthAdd: "Add length",
      ArbStatCopulaEntryKlineFilterLengthRemove: "Remove",
      ArbStatCopulaEntryKlineFilterLengthsHint:
        "Strictly increasing, at least 2 items; SMA/EMA/WMA/VWMA default 10 / 20 / 30",
      ArbStatCopulaEntryKlineFilterOscLength: "Indicator period",
      ArbStatCopulaEntryKlineFilterNatrExpandLength: "ATR period",
      ArbStatCopulaEntryKlineFilterNatrExpandHint:
        "range_high is a TR/ATR multiple, not NATR%. Typical value is ~1; 2.0 means at most about 2× recent ATR. Recommended: period 14, range 0–2.0, inside_range. Stricter 1.5; extreme-only 2.5–3.0.",
      ArbStatCopulaEntryKlineFilterNatrExpandRangeUnit:
        "Multiple, not volatility percent",
      ArbStatCopulaEntryKlineFilterNatrExpandPredicatesHint:
        "Exactly one: inside_range (default, allow open when expand is within the cap) or outside_range",
      ArbStatCopulaEntryKlineFilterPredicates: "Predicate kinds",
      ArbStatCopulaEntryKlineFilterPredicatesHint:
        "MA types: trend/range only; CCI/RSI: inside/outside range only; Stoch RSI keeps reversal and can add the other checks; at least one per rule",
      ArbStatCopulaEntryKlineFilterPredicateAdd: "Add predicate",
      ArbStatCopulaEntryKlineFilterPredicateRemove: "Remove",
      ArbStatCopulaEntryKlineFilterPredicate_trend_with_open:
        "Trend aligned with entry",
      ArbStatCopulaEntryKlineFilterPredicate_trend_against_open:
        "Trend opposite to entry",
      ArbStatCopulaEntryKlineFilterPredicate_trend_block_open:
        "Block entry in trend",
      ArbStatCopulaEntryKlineFilterPredicate_range_allow_both:
        "Range allows both sides",
      ArbStatCopulaEntryKlineFilterPredicate_range_block_both:
        "Block entry in range",
      ArbStatCopulaEntryKlineFilterPredicate_outside_range: "Outside range",
      ArbStatCopulaEntryKlineFilterPredicate_inside_range: "Inside range",
      ArbStatCopulaEntryKlineFilterPredicate_stoch_rsi_reversal:
        "Stoch RSI reversal (required)",
      ArbStatCopulaEntryKlineFilterPredicate_stoch_rsi_entry_cross:
        "Entry K/D cross",
      ArbStatCopulaEntryKlineFilterPredicate_stoch_rsi_exit_cross:
        "Exit K/D cross",
      ArbStatCopulaEntryKlineFilterPredicate_stoch_rsi_exit_independent:
        "Close when the condition is met",
      ArbStatCopulaEntryKlineFilterPredicate_stoch_rsi_exit_with_signal:
        "Also require the condition on signal revert",
      ArbStatCopulaEntryKlineFilterStochPredicatesHint:
        "Reversal stays and cannot be removed. Entry cross only flips the entry K/D side. Exit cross only adds K/D to a close and does not enable it. Independent close and signal close are mutually exclusive. With neither, Stoch does not close. Hold time still closes on expiry.",
      ArbStatCopulaEntryKlineFilterStochPredicateInvalid:
        "Invalid Stoch RSI predicates: reversal is required, kinds cannot repeat, and independent close cannot be combined with signal close",
      ArbStatCopulaEntryKlineFilterRange: "Value range",
      ArbStatCopulaEntryKlineFilterRangeLow: "Low",
      ArbStatCopulaEntryKlineFilterRangeHigh: "High",
      ArbStatCopulaEntryKlineFilterFactorTypeInvalid:
        "Select a valid factor type",
      ArbStatCopulaEntryKlineFilterPeriodInvalid:
        "Period must be a subset of K-line periods above",
      ArbStatCopulaEntryKlineFilterLengthsInvalid:
        "Lengths must be strictly increasing integers (each ≥ 2, no duplicates)",
      ArbStatCopulaEntryKlineFilterPredicatesInvalid:
        "Select at least one predicate kind",
      ArbStatCopulaEntryKlineFilterRangeInvalid: "Range requires low < high",
      ArbStatNoTradeSchedule: "No-trade schedule",
      ArbStatNoTradeScheduleEnabled: "Enable no-trade schedule",
      ArbStatNoTradeScheduleHint:
        "Blocks new opens only (not closes); half-open [start,end); overnight/week-wrap OK; all-day block needs multiple windows. Switch off = no restriction.",
      ArbStatNoTradeTimezone: "Timezone",
      ArbStatNoTradeWindowItemTitle: "Window {index}",
      ArbStatNoTradeWindowAdd: "Add window",
      ArbStatNoTradeWindowRemove: "Remove",
      ArbStatNoTradeWindowType: "Type",
      ArbStatNoTradeWindowType_daily: "Daily",
      ArbStatNoTradeWindowType_weekly: "Weekly",
      ArbStatNoTradeStart: "Start time",
      ArbStatNoTradeEnd: "End time",
      ArbStatNoTradeStartDow: "Start weekday",
      ArbStatNoTradeEndDow: "End weekday",
      ArbStatNoTradeDow_1: "Mon",
      ArbStatNoTradeDow_2: "Tue",
      ArbStatNoTradeDow_3: "Wed",
      ArbStatNoTradeDow_4: "Thu",
      ArbStatNoTradeDow_5: "Fri",
      ArbStatNoTradeDow_6: "Sat",
      ArbStatNoTradeDow_7: "Sun",
      ArbStatNoTradeNeedOneWindow: "Add at least one no-trade window",
      ArbStatNoTradeTypeInvalid: "Window type must be daily or weekly",
      ArbStatNoTradeClockInvalid: "Time must be HH:mm",
      ArbStatNoTradeDowInvalid: "Weekday must be 1 (Mon) .. 7 (Sun)",
      ArbStatNoTradeStartEndMustDiffer: "Start and end must differ",
      ArbStatCointRatioRsiExitEnabled: "RSI mean-reversion exit (coint ratio)",
      ArbStatCointRatioRsiLength: "RSI period (default 14)",
      ArbStatCointRatioRsiUpper: "Upper band (default 70)",
      ArbStatCointRatioRsiLower: "Lower band (default 30)",
      ArbStatCointRatioRsiMinProfitFrac: "Min profit vs target (default 0.2)",
      ArbStatCointRatioRsiUseSymmetricArms:
        "Symmetric arms (direction-agnostic)",
      ArbStatCointRatioRsiParamsInvalid:
        "RSI exit: period must be an integer ≥ 2;0 ≤ lower < upper ≤ 100; profit fraction must be in (0, 1].",
      ArbStatMinGainCoint: "Coint position take-profit ratio",
      ArbStatMaxDrawdownCoint: "Coint position stop-loss ratio",
      ArbStatCointStopLossCooldownEnabled:
        "Enable consecutive stop-loss cooldown",
      ArbStatCointStopLossLimit: "Consecutive coint stop-loss count",
      ArbStatCointStopLossCooldownMinutes: "Stop-loss cooldown",
      ArbStatCointStopLossCooldownHint:
        "After N consecutive coint stop-losses on a pair, block re-entry on that pair. This is not the regular post-close cooldown (~100s). Disable by sending -1, never 0.",
      ArbStatCointStopLossCooldownParamsInvalid:
        "Stop-loss count must be an integer ≥ 1; cooldown must be at least 1 minute.",
      ArbStatCointVolScaleEnabled: "Cointegration vol scaling",
      ArbStatCointVolScaleHint:
        "Enable Dynamic TP/SL first. When on, MinGain, MaxDrawdown and tier/trail USD thresholds scale with relative volatility; server buffers decide when it applies.",
      ArbStatCointVolScaleWindow: "Short-window diff count",
      ArbStatCointVolScaleMinMult: "Scale clamp min",
      ArbStatCointVolScaleMaxMult: "Scale clamp max",
      ArbStatCointVolScaleWindowInvalid:
        "Short-window count must be an integer ≥ 2.",
      ArbStatCointVolScaleMultInvalid:
        "Clamp min/max must be positive and min must be less than max.",
      ArbStatCointDynamicPnlTierTrail: "Dynamic TP/SL",
      ArbStatCointTrailArmFrac: "Trail arm fraction",
      ArbStatCointTrailPullbackMult: "Trail pullback mult",
      ArbStatCointTier1GainFrac: "Tier-1 gain fraction",
      ArbStatCointTier1StopMult: "Tier-1 stop-loss multiplier",
      ArbStatMaxHoldMinutes: "Max hold time",
      ArbStatMaxHoldExitMode: "Max-hold exit",
      ArbStatMaxHoldExitModeFixedTime: "Fixed hold time",
      ArbStatMaxHoldExitModeStoch: "Stoch RSI reversal",
      ArbStatMaxHoldExitModeStochHint:
        "Replaced by predicates. A legacy reversal value migrates to an independent close. Hold time still closes on expiry.",
      ArbStatMaxHoldExitModeInvalid:
        "Invalid exit mode. Choose fixed hold time or Stoch RSI reversal",
      ArbStatMaxHoldExitModeNeedsStoch:
        "Stoch RSI reversal exit requires exactly one Stoch RSI filter",
      ArbStatMaxHoldExitModeStochConflict:
        "A legacy Stoch RSI reversal exit cannot be combined with signal close",
      ArbStatEnableHoldPnLCurve: "Enable hold PnL curve",
      ArbStatHoldPnLEnvelopeSegments: "Envelope segments",
      ArbStatHoldPnLParamsInvalid:
        "Hold PnL curve: segments must be an integer from 8 to 128.",
      MinutesUnit: "min",
      IsMoveGrid: "Move Grid",
      FollowBook: "Follow OrderBook",
      InvestmentAmount: "Investment Amount",
      IsCollabExec: "Collaborative Execution",
      IsTrendExec: "Trend Execution",
      IsSyncOrder: "Sync Order",
      IsOpenArb: "Open Arbitrage",
      AuthorizedObserver: "Authorize Observer",
      PositionAvailable: "Avbl Position",
      PositionInit: "Init Position",
      KlineCycle: "K Line Cycle",
      OpenPositionQuantile: "Open Price",
      ClosePositionQuantile: "Close Price",
      Leverage: "Leverage",
      IsLong: "Long",
      IsShort: "Short",
      IsBoth: "Both",

      IsUseCurrentPosition: "Inherit position",
      IsNotReQuote: "Quote only once",
      IsOpen: "Open Position",
      Side: "Side",
      OnlyLong: "Long",
      OnlyShort: "Short",
      LongAndShort: "Long/Short",
      StrongDecision: "Strong Assessment",
      BuyOrderSpacingRatio: "Buy Rang Ratio",
      SellOrderSpacingRatio: "Sell Rang Ratio",
      EquivalentRatio: "Geometric",
      EquivalentDifferences: "Arithmetic",
      TakeProfitStopLoss: "TP/SL ",
      TakeProfit: "TP",
      StopLoss: "SL",
      PriceRange: "Price Range",
      HighPoint: "High",
      LowPoint: "Low",
      BuyOrder: "Buy",
      SellOrder: "Sell",
      PendingOrderLogarithm: "Pending order logarithm",
      SymbolSettings: "Symbol Settings",
      RateGridLongSymbol: "Long Symbol",
      RateGridTradeSymbol: "Short Symbol",
      AddCurrentSymbol: "Add Symbol",
      AddCurrentCurrency: "Add Symbol",
      GoBack: "Back",
      Confirm: "Confirm",

      MaxOrderQty: "Max Order Qty",
      ExecConfig: "Executor Configuration",
      ExecMinOrderQty: "Minimum Order Quantity",
      ExecMaxSplitOrder: "Max Split Orders",
      ExecBaseSplitOrder: "Base Split Orders",
      ExecOrderTimeout: "Order Timeout",
      ExecTimeout: "Total Timeout",
      ExecTimeoutTaker: "Timeout Taker Action",

      NO_MARGIN: "No Margin",
      NO_SIDE_EFFECT: "Margin And No Auto Borrow/Repay",
      MARGIN_BUY: "Auto Borrow",
      AUTO_REPAY: "Auto Repay",
      AUTO_BORROW_REPAY: "Auto Borrow/Repay",

      ArbFundingConfig: "Funding Rate Arbitrage Configuration",
      Tips: "Tips",
      CurrencyWhiteList: "Currency White List",
      MaxTradeQty: "Max Trade Qty",
      TriggerFundingRateThreshold: "Trigger Funding Rate Threshold",
      TriggerFundingRateMinute: "Trigger Funding Rate Start Time",
      TriggerSpotSide: "Trigger Spot Side",
      TriggerSpotAll: "Trigger Spot All",
      TriggerSpotBuy: "Trigger Spot Buy",
      TriggerSpotSell: "Trigger Spot Sell",
      MinSplitUsd: "Min Split Usd",
      MaxSplitUsd: "Max Split Usd",
      BaseSplitCount: "Base Split Count",
      PleaseSetCurrencyWhiteList: "Please Set Currency White List",
      TriggerTime: "Trigger Time",
      CurrentFundingRate: "Current Funding Rate",
      CurrentFundingRateTime: "Current Funding Rate Time",
    },
    Command: {
      Running: "Running",
      History: "History",
      ObserverRunning: "Observer Running",
      ObserverHistory: "Observer History",
      RiskRunning: "RC Running", // Risk Control Running
      RiskHistory: "RC History", // Risk Control History

      Instance: {
        ShowZeroPosition: "Show History Position",
        //Options
        Equity: "Account Equity",
        TotalEquityUsd: "Account Equity (USD)",
        Im: "Initial Margin Rate",
        Mm: "Maintenance Margin Rate",
        TotalFloating_Profit_Loss_Usd: "Profit and Loss(USD)",
        TotalProfit_Loss: "Profit and Loss",
        Roi: "ROI",
        Total_Delta: "Delta",
        Total_Gamma: "Gamma",
        Total_Vega: "Vega",
        Total_Theta: "Theta",
        Total_Rho: "Rho",

        SubAccount: "Sub Account",
        All: "All",
        SelectionPeriod: "Period",

        StopInstance: "Stop Instance",
        Tags: "Tags",
        EditTags: "Edit",
        FilterByTags: "Filter by tags",
        TagEditTitle: "Edit Tags",
        TagCurrent: "Current tags",
        TagAdd: "Add tag",
        TagEmptyHint: "No tags yet",
        TagInputHint: "Type and press Enter to add",
        TagHistoryLabel: "History (click to add)",
        TagPlaceholder: "Enter tag",
        TagConfirm: "Confirm",
        TagCancel: "Cancel",
        TagSaveFailed: "Failed to save tags. Please try again.",
        ChangeParameters: "Change Params",
        ReuseParameters: "Reuse Params",
        Archive: "Archive",
        PositionOverview: "Position Overview",
        ReplayProgressTitle: "Replay progress",
        ReplayProgressPct: "Current progress",
        ReplayElapsedSim: "Simulated elapsed",
        ReplayEffectiveRate: "Effective replay rate",
        ReplaySimClock: "Simulated clock",
        ReplayTimeRange: "Replay time range",
        ReplayDataUpdatedAt: "Last progress update",

        //价差套利
        ArbSpreadOverview: "Arb Spread Overview",

        //运行状况
        ArbSpreadRunStatus: "Run Status",
        ArbSpreadTotalCount: "Total Count",
        ArbSpreadTotalEstimatedReturn: "Total Estimated Return",
        ArbSpreadTotalRealReturn: "Total Real Return",
        ArbSpreadTotalSlippage: "Total Slippage",

        //订单下单耗时
        ArbSpreadOrderDurationData: "Order Duration Data",
        ArbSpreadOrderDurationAvg: "Avg Order Duration",
        ArbSpreadOrderDurationMax: "Best Order Duration",
        ArbSpreadOrderDurationMin: "Worst Order Duration",

        //收益率
        ArbSpreadReturnData: "Return Data",
        ArbSpreadReturnAvg: "Avg Return",
        ArbSpreadReturnMax: "Best Return",
        ArbSpreadReturnMin: "Worst Return",

        //滑点
        ArbSpreadSlippageData: "Slippage Data",
        ArbSpreadSlippageAvg: "Avg Slippage",
        ArbSpreadSlippageMax: "Best Slippage",
        ArbSpreadSlippageMin: "Worst Slippage",

        //套利详情
        ArbSpreadDetail: "Arb Spread Detail",
        ArbSpreadDetailId: "ID",
        ArbSpreadDetailTime: "Time",
        ArbSpreadDetailAction: "Action",
        ArbSpreadDetailBuySymbol: "Buy Symbol",
        ArbSpreadDetailSellSymbol: "Sell Symbol",
        ArbSpreadDetailBuyPrice: "Buy Price",
        ArbSpreadDetailSellPrice: "Sell Price",
        ArbSpreadDetailEstimateReturn: "Estimate Return",
        ArbSpreadDetailRealReturn: "Real Return",
        ArbSpreadDetailSlippage: "Slippage",
        ArbSpreadDetailSyncDuration: "Sync Duration",
        ArbSpreadDetailBuyOrderDuration: "Buy Order Duration",
        ArbSpreadDetailSellOrderDuration: "Sell Order Duration",

        CollabExecOverview: "Collab Exec Overview",
        CollabExecRunData: "Execution Data",
        CollabExecToTalCount: "Trade Count",
        CollabExecAvgWaitDurationMs: "Avg Wait Duration(ms)",
        CollabExecUpdateTime: "Last Update Time",
        CollabExecRunTime: "Run Time",

        CollabExecSlippageData: "Slippage Data",
        CollabExecAvgSlippageBps: "Avg Slippage(Bps)",
        CollabExecMaxSlippageBps: "Best Slippage(Bps)",
        CollabExecMinSlippageBps: "Worst Slippage(Bps)",

        CollabExecSlippageLoss: "Slippage Loss",
        CollabExecTotalSlippageLoss: "Total Slippage Loss(USD)",
        CollabExecAvgSlippageLoss: "Avg Slippage Loss(USD)",
        CollabExecMaxSlippageLoss: "Best Slippage Loss(USD)",
        CollabExecMinSlippageLoss: "Worst Slippage Loss(USD)",

        ArbFundingOverview: "Funding Rate Arbitrage Overview",
        TotalTradeQty: "Total Trade Qty",
        TotalFundingProfit: "Total Funding Profit",
        TotalCloseProfit: "Total Close Profit",
        TotalOrderFee: "Total Order Fee",
        TotalEstimatedBorrowInterest: "Total Estimated Borrow Interest",
        TotalNetProfit: "Total Net P&L",

        TradeQty: "Trade Qty",
        PreFundingRate: "Pre Funding Rate",
        RealFundingRate: "Real Funding Rate",
        RealFundingProfit: "Real Funding Profit",
        CloseProfit: "Close Profit",
        EstimatedBorrowInterest: "Estimated Borrow Interest",
        SettleTimes: "Settle Times",

        TradeRecord: "Trade Record",
        InitiallyAvailable: "Fund Size",
        TotalTransaction: "Amount",
        StrategicBenefits: "Realized Profit",
        TotalHoldingProfit: "UnRealized Profit",
        TotalProfit: "Total Profit",
        CurrentPosition: "Open Position",
        PositionDirection: "Side",
        BuyAvgPrice: "Buy Avg Price",
        SellAvgPrice: "Sell Avg Price",
        TransactionQty: "Amount",
        Progress: "Progress",
        EsmaticRemainTime: "Estimated Remain Time",
        AverageHoldingPrice: "Position Avg Price",
        MarkPrice: "Mark Price",
        Notional: "Notional",
        MaxPositionNotional: "Max Position Notional",
        HoldingProfit: "UnRealized Profit",
        PolicyDetails: "Details",
        IncomeLevel: "PNL Level",
        HighIncomeLevel: "Peak Level",
        LowIncomeLevel: "Bottom Level",
        MaximumDrawdown: "Max Drawdown",
        SingleProfit: "Single Profit",
        MaximumProfit: "Max Profit",
        MinimumProfit: "Min Profit",
        MaximumLoss: "Max Loss",
        MinimumLoss: "Min Loss",
        ProfitAndLossTimes: "PNL Times",
        ProfitTimes: "Profit Times",
        LossTimes: "Loss Times",
        ProfitAndLoss: "PNL",
        TotalProfit2: "Total Profit",
        TotalLoss: "Total Loss",
        TotalRebate: "Total Fees",
        NetProfit: "Net Profit",
        NetPosition: "Net Position",
        ProfitAndLossRatio: "PNL(%)",
        TransactionVolume: "Volume",
        Buy: "Buy",
        Sell: "Sell",
        Total: "Total",
        TransactionRole: "Trade Role",
        TakerCount: "Taker Times",
        MakerCount: "Maker Times",
        TakerQty: "Taker Amount",
        MakerQty: "Maker Amount",
        WinRate: "Win Rate",
        Detail: "Detail",
        SubAccountBalance: "Sub Account Balance ",
        StrategyStatus: "Status",
        AccountType: "Type",
        StartupTime: "Start",
        ArbStatParamSummary: "Param Settings",
        StopConfirm: "Stop instance?",
        StopConfirmTips: "The operation cannot be undone!",
        Confirm: "Confirm",
        Cancel: "Cancel",
        ActionSuccess: "Successful",
        ActionFailed: "Failed",

        CurrentPositionDirection: "Side",
        Time: "Time",
        CumBuyU: "CUM Buy(U)",
        CumBuyC: "CUM Buy(C)",
        AvgBuyPrice: "Avg Buy Price",
        CumSellU: "CUM Sell(U)",
        CumSellC: "CUM Buy(C)",
        AvgSellPrice: "Avg Sell Price",
        InitPosition: "Init Position Qty",
        CurrPosition: "Curr Position Qty",
        CurrVolumn: "Curr Volume",
        CurrValue: "Curr Value",

        GroupId: "Set ID",
        BuyAmount: "Buy Qty",
        SellAmount: "Sell Qty",
        BuyQty: "Buy Amount",
        SellQty: "Sell Amount",
        Profit: "PNL",
        OrderFee: "Fee",
        StartTime: "Start",
        RunTime: "Run Time",
        Action: "Action",

        Day: "d",
        Hour: "h",
        Minute: "m",
        Second: "s",

        ProfitModal: {
          YieldCurve: "Yield Curve",
          IgnoreTransactionFees: "Ignore transaction fees",
          BacktestSymbolFilter: "Pair combination filter",
          BacktestPeriodFilter: "Signal period filter",
          BacktestSlippageCorrection: "Impact coefficient",
          BacktestSlippagePermyriadUnit: "permyriad (‱)",
          BacktestFeeRateCorrection: "Fee rate",
          CumulativeIncome: "Cumulative PNL",
          AverageValue: "Average",
          SingleIncome: "PNL Per Trade",
          IsLong: "Long",
          IsShort: "Short",
        },
        GroupModal: {
          IntraGroupTransactionRecord: "Trade Record",
          ShowOnlyTradedOrders: "Show executed orders only",
          OrderTime: "Order Time",
          TransactionTime: "Trade Time",
          TransactionDirection: "Side",
          TargetPrice: "Target Price",
          TargetAmount: " Target Amount",
          AvgPrice: "Avg Price",
          Vol: "Volume",
          Qty: "Amount",
          Role: "Role",
          Status: "Status",
          OrderFee: "Fee",
          Total: "Total",
          Record: "Records",
          TotalAvgPrice: "Total Avg Price",
          TotalVol: "Total Filled Qty",
          TotalAmount: "Total Amount",
        },
        ArbStat: {
          ArbitrageRecord: "Arbitrage Record",
          ViewDetail: "View Detail",
          NoOrderData: "No order data",
          IncomeStats: "Income Statistics",
          SignalIndicator: "Signal Indicator",
          JointStrength: "Joint Strength",
          Confidence: "Confidence",
          StrengthThreshold: "Strength Threshold",
          AvgCorrelation: "Avg Correlation",
          CloseReason: "Close Reason",
          LongShortDeviationScore: "Long/Short Deviation Score",
          DeviationScore: "Deviation Score",
          LongScore: "Long Score",
          ShortScore: "Short Score",
          Overvalued: "Overvalued",
          Undervalued: "Undervalued",
          StopLoss: "Stop Loss",
          TakeProfit: "Take Profit",
          PositionTimeout: "Position Timeout",
          SignalRegression: "Signal Regression",
          PairReversal: "Pair Reversal",
          RhoDrop: "Correlation Drop",
          PositionTakeProfit: "Position Take Profit",
          CointTrailingStop: "Trailing Stop",
          PositionStopLoss: "Position Stop Loss",
          EmergencyStop: "Emergency Stop",
          InstanceStop: "Instance Stop",
          PositionSizeLimit: "Position Size Limit",
          CloseReasonLegacyResume: "Resume Close (Legacy)",
          Max: "Max",
          Min: "Min",
          OpenTime: "Open Time",
          BuySymbol: "Buy Symbol",
          SellSymbol: "Sell Symbol",
          OpenSize: "Open Size",
          SignalPeriod: "Signal Period",
          OpenBuyPrice: "Open Buy Price",
          OpenSellPrice: "Open Sell Price",
          CloseTime: "Close Time",
          CloseSellPrice: "Close Sell Price",
          CloseBuyPrice: "Close Buy Price",
          TotalProfit: "Total Profit",
          TotalFee: "Total Fee",
          NetProfit: "Net Profit",
          ReturnRatio: "Return Ratio",
          NetProfitRatio: "Net Return Ratio",
          ExecutionSlippageRate: "Execution Slippage Rate",
          TakerSlippageRate: "Taker Slippage Rate",
          SlippageVsL1Maker: "L1 Maker Slippage",
          SlippageVsTakerPrice: "Taker Spread",
          TotalCostVsTaker: "Cost Savings",
          TotalCostSkipDepthInsufficient: "Insufficient depth",
          TotalCostSkipFeeRateMissing: "Fee rate not captured",
          TotalCostSkipBenchmarkIncomplete: "Benchmark incomplete",
          TotalCostTooltipPrice: "Price",
          TotalCostTooltipFee: "Fee",
          TotalCostTooltipSkip: "Not computed",
          TakerBenchFillPct: "Sweepable fill",
          TakerSlippageCovered: "Covered basis",
          TotalCostCovered: "Covered basis",
          HoldAnalysis: "Hold Analysis",
          HoldOverviewTitle: "Hold PnL Structure Overview",
          HoldOverviewScatterSeries: "Trigger PnL",
          HoldOverviewCandleSeries: "Cumulative equity (candlestick)",
          HoldOverviewCumYAxis: "Cumulative net (USD)",
          HoldOverviewCumNet: "Cumulative net PnL",
          HoldOverviewTradeNet: "Trade net PnL",
          HoldOverviewCumHigh: "Cumulative equity high",
          HoldOverviewCumLow: "Cumulative equity low",
          HoldOverviewExecVolume: "Execution cost",
          HoldOverviewCumExecCostLine: "Cumulative execution cost",
          HoldOverviewAvgExecCostLine: "Average execution cost",
          HoldOverviewTipOpen: "O",
          HoldOverviewTipHigh: "H",
          HoldOverviewTipLow: "L",
          HoldOverviewTipClose: "C",
          HoldOverviewTipCost: "Cost",
          HoldOverviewTipGiveBack: "Giveback",
          HoldOverviewMfeApprox: "Max floating profit (trigger est.)",
          HoldOverviewGiveBackHint: "Give-back from peak to net",
          HoldOverviewYAxis: "PnL (USD)",
          HoldOverviewPermYAxis: "Permyriad (‱)",
          HoldOverviewMaePermLine: "Max Floating Loss Ratio",
          HoldOverviewMfePermLine: "Max Floating Profit Ratio",
          HoldOverviewMfeBar: "Max Floating Profit",
          HoldOverviewNetBar: "Net PnL",
          HoldOverviewMaeBar: "Max Floating Loss",
          HoldOverviewExecCostBar: "Execution Cost",
          HoldOverviewGiveBack: "Give-back from peak",
          HoldOverviewNoData: "No closed trades",
          HoldTriggerPnl: "Trigger PnL",
          HoldGrossFallback: "Gross profit (no hold curve)",
          HoldGiveBackFromPeak: "Give-back from peak",
          HoldDuration: "Hold Duration",
          HoldNoCurveBadge: "No hold curve data",
          HoldIncompleteBadge: "Replay-truncated hold",
          HoldPnLNoData: "No hold curve for this trade",
          HoldSelectHint: "Click a trade on the charts above",
          HoldSelectedTrade: "Selected trade",
          HoldEnvelopeTitle: "Hold PnL Envelope",
          HoldEnvelopeBand: "Segment band",
          HoldEnvelopeCandle: "Segment candlestick",
          HoldEnvelopePath: "Segment path",
          HoldEnvelopeMax: "Segment max",
          HoldEnvelopeMin: "Segment min",
          HoldEnvelopeFirst: "Segment first",
          HoldEnvelopeLast: "Segment last",
          HoldEnvelopeSparseHint: "Sparse segments; empty gaps have no samples",
          HoldEnvelopeNoSample: "No samples in this segment",
          HoldProgressAxis: "Hold progress",
          HoldUnrealizedPnl: "Unrealized PnL (USD)",
          HoldProfitTarget: "Profit target",
          HoldEffectiveStop: "Effective stop",
          HoldMFE: "MFE",
          HoldMAE: "MAE",
          HoldTFP: "TFP",
          HoldPctTimeInProfit: "Time in profit",
          HoldAttributionTitle: "PnL Attribution",
          HoldAttributionComposition: "PnL composition",
          HoldAttributionRealizedPnL: "Realized P/L",
          HoldExecutionLeak: "Execution leak",
          HoldFeeImpact: "Fees",
          ExecutionEvaluation: "Execution Evaluation",
          ExecutionCostComparison: "Per-Trade Execution Cost",
          ExecutionSavingComparison: "Per-Trade Execution Saving",
          ExecutionCostUsd: "Execution Cost",
          ExecutionSaving: "Execution Saving",
          PriceSaving: "Price Saving",
          FeeSaving: "Fee Saving",
          CumulativeSaving: "Cumulative Saving",
          CostToGrossRatio: "Cost / Gross",
          CostRatioBasisNetAbs: "loss trade, |net| denominator",
          CostRatioBasisLossZone: "non-positive gross, off-threshold",
          ExecutionTiming: "Leg Sync & Window",
          ExecutionTimingAndThroughput: "Leg Sync, Window & Throughput",
          TradeThroughput: "Exec Throughput",
          LegDurationSkew: "Leg Duration Spread",
          TotalExecWindow: "Total Exec Window",
          ExecutionDiagnostic: "Execution Diagnostic",
          ExecutionDiagnosticHint:
            "Green=profit Red=loss · Size=volume · X=cost/turnover(‱, neg=better vs L1) · Dashed=threshold",
          DiagnosticAxisCost: "Exec Cost / Volume (‱, neg=better vs L1)",
          DiagnosticAxisSkew: "Same-Side Leg Spread (s)",
          DiagnosticCostTurnover: "Exec Cost / Volume",
          DiagnosticExecutionCost: "Exec Cost (USD, neg=saving)",
          DiagnosticCostGrossSkip: "— (thin gross, N/A)",
          DiagnosticCumQuote: "4-Leg Volume",
          DiagnosticCostThreshold: "4‱ cost",
          DiagnosticSkewThreshold: "30s sync",
          QuadrantIdeal: "① Ideal",
          QuadrantWarnSync: "② Poor sync",
          QuadrantWarnCost: "③ High cost",
          QuadrantWorst: "④ Caution",
          TradeNetProfit: "Net Profit",
          NoTimingData: "No four-leg duration data",
          LegExecutionVelocity: "Four-Leg Fill Velocity",
          LegOpenBuy: "Open Buy",
          LegOpenSell: "Open Sell",
          LegCloseBuy: "Close Buy",
          LegCloseSell: "Close Sell",
          LegDuration: "Duration",
          LegVelocityUnit: "USD/s",
          NoExecutionData: "No execution cost data",
          NoLegDurationData: "No four-leg duration data",
          Action: "Action",
          ChartModeGlobal: "Global",
          ChartModeLegs: "Three symbols",
          ChartModeBtcEth: "BTC-ETH",
          ChartModeBtcSol: "BTC-SOL",
          ChartModeEthSol: "ETH-SOL",
          ChartModeXagXau: "XAG-XAU",
          ChartModeCopperXau: "COPPER-XAU",
          PoolSectionLabel: "Pool",
          PoolCrypto: "BTC-ETH-SOL",
          PoolMetal: "XAU-XAG-COPPER",
          AssetClassSectionLabel: "Asset class",
          AssetClassCrypto: "Crypto",
          AssetClassFuturesmkt: "Traditional futures",
          PoolSoyChain: "S-ZL-ZM",
          PoolGrains: "C-S-W",
          PoolUsIndex: "ES-NQ-YM",
          PoolPreciousMetals: "MGC-SI-HG",
          PoolCommodityFx: "AD-CD-NE",
          ModeSectionLabel: "View",
          MarketSectionLabel: "Market",
          MarketSpot: "Spot",
          MarketFutures: "Futures",
          ExchangeSectionLabel: "Exchange",
          ExchangeBinance: "Binance",
          ExchangeOkx: "OKX",
          UniverseLockedWhileEditing:
            "Cannot change asset class or pool while editing (crypto also locks exchange and market). Cancel update first.",
          FilterState: "State",
          FilterSector: "Sector",
          SectorAll: "All",
          StateAll: "All",
          StateActive: "Active",
          StatePending: "Pending",
          StateRetired: "Retired",
          StatePaused: "Paused",
          LoadingPools: "Loading pools…",
          LoadingFailed: "Failed to load, please retry later",
          NoPools: "No pools available",
          SearchPlaceholder: "Search pairs…",
          NoSearchResults: "No matching pairs",
        },
        Charts: {
          TimelineCycle: "Transaction & Return Rate",
          EfficiencyBubble: "Slippage & Duration",
          TransactionReturn: "Transaction Return",
          OpenClosePoints: "Open/Close Points",
        },
      },
    },
  },

  AINEws: {
    Title: "AI Live News",
    ImportantOnly: "Important only",
    ScrollToLoadMore: "Scroll down to load more",
    NoMoreMessages: "No more messages",
    Today: "Today",
    Important: "Important",
    Normal: "Normal",
  },
  ModalInfo: {
    ConfirmCancelExchange: "Do you confirm to cancel this pending order?",
    ConfirmCancelBail: "Do you confirm the cancellation of the delegation?",
    ConfirmCancelAllExchange: "Do you confirm to cancel all pending orders?",
    ConfirmMarketClosePosition: "Do you confirm market price closing?",
    ConfirmOrder: "Do you confirm the order?",

    ConfirmTips: "This operation cannot be undone!",
    Yes: "Yes",
    No: "No",
    CancelAction: "Cancel operation",
    ActionSuccess: "Operation successful",
    ActionFailed: "Operation failed",
  },

  ExchangeName: {
    All: "All",
    Binance: "Binance",
    Okex: "OKX",
    Huobi: "Huobi",
    Coinbase: "Coinbase",
    Deribit: " Deribit",
    AISelect: "AI Select",
    Bybit: "Bybit",
    Gate: "Gate",
    TradingX: "TradingX",
    Aster: "Aster",
    Sunx: "SUNX",
    XCoin: "XCoin",
    Bitget: "Bitget",
    Futuresmkt: "Traditional Futures",
    CBOT: "CBOT",
    CME: "CME",
    COMEX: "COMEX",
    EUREX: "EUREX",
    HKEX: "HKEX",
    NYMEX: "NYMEX",
    SGX: "SGX",
  },
  AccountType: {
    Spot: "Spot",
    Future: "USDⓈ-M",
    Swap: "COIN-M",
    Option: "Option",
    Index: "Index",
  },
  OkxAccountType: {
    SPOT: "Spot",
    SWAP: "Perpetual",
    SWAPALL: "Perpetual Contract",
    FUTURES: "Delivery",
    FUTURESALL: "Delivery Contract",
  },
  GateAccountType: {
    SPOT: "Spot",
    FUTURES: "Perpetual",
    FUTURESALL: "Perpetual Contract",
    DELIVERY: "Delivery",
    DELIVERYALL: "Delivery Contract",
  },
  BybitAccountType: {
    SPOT: "Spot",
    LINEAR: "USD Contract",
    INVERSE: "Inverse Contract",
    OPTION: "Option",
    spot: "Spot",
    linear: "USD Contract",
    inverse: "Inverse Contract",
    Perpetual: "Perpetual",
    Inverse: "Inverse",
  },
  SunxAccountType: {
    SWAP: "Perpetual",
  },
  XcoinAccountType: {
    SPOT: "Spot",
    LINEAR_PERPETUAL: "Linear Perpetual",
    LINEAR_FUTURES: "Linear Futures",
  },
  Kchart: {
    SaveStudy: "Save Study",
    LoadStudy: "Load Study",
  },
  KChartBox: {
    SelectInterval: "Select Intervals",
    Edit: "Edit",
    Save: "Save",
  },
  FuturesSymbol: {
    GC0W_CMX: "Golden Master Company",
    SI0W_CMX: "Silver Master Company",
    HG0W_CMX: "Copper Main Company",
    PL0W_NMX: "Platinum Main Company",
    CL0W_NMX: "WTI crude oil main connection",
    NG0W_NMX: "Natural gas main company",
    RB0W_NMX: "RBOB gasoline main company",
  },
  AstockSymbol: ASTOCK_LIST,
  ArbSelect: {
    Portfolio: "Portfolio",
    ThreeDayCumulativeFundingRateShort: "3D Funding%",
    ThreeDayCumulativeFundingRate: "3d Funding APR",
    ThreeDayCumulativeYield: "3d Yield",
    SevenDayCumulativeFundingRate: "7d Funding APR",
    SevenDayCumulativeYield: "7d Yield",
    ThirtyDayCumulativeFundingRate: "30d Funding APR",
    ThirtyDayCumulativeYield: "30d Yield",
    APR: "APR",
    FundingRate: "Funding Rate",
    FundingRateHistory: "Funding Rate History",
    RealTimeFundingRate: "Real-time Funding Rate",
    FundingInterval: "Funding Rate Interval",
    Time: "Time",
    TimeInterval: "Time Interval",
    TimeToNextFunding: "Time to Next Funding",
    NextFunding: "Next Funding Rate",
    Hour: "h",
    BaseInterestRate: "Base Interest Rate",
    FundingRateUpperLimitLowerLimit: "Funding Rate Upper/Lower Limit",
    MarkPrice: "Mark Price",
    CountDown: "Countdown",
    DeliveryCountDown: "Delivery Countdown",
    History: "History",
    Contract: "Contract",
    SpreadTrend: "Spread Trend",
    Chart: "Chart",
    Day: "Day",
    Days: "Days",
  },
  SpreadArb: {
    All: "All",
    Spot: "Spot",
    Contract: "Contract",
    Delivery: "Delivery",
    Other: "Other",
    APR: "APR",
    Leg1: "Leg 1",
    Leg2: "Leg 2",
    BuySymbol: "Buy Symbol",
    SellSymbol: "Sell Symbol",
    Spread: "Spread",
    SpreadRate: "Spread Rate",
    Change: "24h Change",
    Expiration: "Expiration",
    Liquidity: "Liquidity",
    Cliquidity: "Liquidity(Coin)",
    Uliquidity: "Liquidity(USDT)",
  },
  NetValue: {
    Title: "Yield Curve",
    MaxDrawdown: "Max Drawdown",
    CumulativeReturn: "Cumulative Return",
    Percentage: "Percentage",
    MaxReturn: "Max Return",
    NetValueCurve: "Net Value Curve",
    Value: "Net Value",
    NetValue: "Net Value",
    Drawdown: "Drawdown",
    ReturnDrawdown: "Return & Drawdown Curve",
    ProfitLoss: "Profit & Loss Curve",
    Profit: "Current P&L",
    DailyReturn: "Daily Return",
    CumulativeProfit: "Cumulative P&L",
    Amount: "Amount",
    Date: "Date",
    Balance: "Balance",
    ReturnRate: "Return Rate",
    HighWaterMark: "High Water Mark",
    LowWaterMark: "Low Water Mark",
    CurrentDrawdown: "Current Drawdown",
    MaxDrawdownCol: "Max Drawdown",
    AnnualizedReturn: "Annualized Return",
    AnnualizedVolatility: "Annualized Volatility",
    Sharpe: "Sharpe",
    SharpeRatio: "Sharpe Ratio",
    DataTable: "Data Table",
    ExportExcel: "Export Excel",
    Transfer: "Transfer",
  },
  TXUI: {
    Orderbook: {
      Merge: "Merge",
      Split: "Split",
    },
  },
  SOROrder: {
    SmartOrderRouting: "Smart Order Routing",
    SubAccountSelector: "Sub-Account Selector",
    AccountsSelected: "sub-accounts selected",
    SelectAll: "Select All",
    AvailableToBuy: "Available to Buy",
    AvailableToSell: "Available to Sell",
    Buy: "Buy",
    Sell: "Sell",
    CanBuy: "Can Buy",
    CanSell: "Can Sell",
    EnableLiquidity: "Enable Liquidity",
    EnableSOR: "Enable SOR",
    EnableCollab: "Enable Collaboration",
    Limit: "Limit",
    Market: "Market",
    Quantity: "Quantity",
    Direction: "Direction",
    TimeInForce: "Time in Force",
    TakeProfit: "Take Profit",
    OrderPrice: "Order Price",
    TriggerPrice: "Trigger Price",
    OrderSummary: "Order Summary",
    Total: "Total",
    Available: "Available",
    TotalBalance: "Total Balance",
    AccountBalance: "Account Balance",
    Symbol: "Symbol",
    Exchange: "Exchange",
    ExcuteSettings: "Execution Settings",
    QuantityRequired: "Quantity cannot be empty",
    QuantityInvalid: "Invalid quantity input",
    SelectSameExchangeSubAccount:
      "Only one sub-account per exchange is allowed!",
  },
  SORCommand: {
    Trading: "Trading",
    History: "Trade History",
    Buy: "Buy",
    Sell: "Sell",
    CurrentOrders: "Current Orders",
    Refresh: "Refresh",
    CancelAll: "Cancel All",
    NoOrders: "No Orders",
    TradeSymbol: "Symbol",
    OrderId: "Order ID",
    OrderVolume: "Order Volume",
    Side: "Side",
    AvgPrice: "Avg Price",
    Progress: "Progress",
    OrderStatus: "Status",
    StartTime: "Start Time",
    EndTime: "End Time",
    TransactionTime: "Transaction Time",
    Action: "Action",
    Stop: "Stop",
    Detail: "Detail",
    OrderDetail: "Order Detail",
    BasicInfo: "Basic Info",
    TradeInfo: "Trade Info",
    ExecutionProgress: "Execution Progress",
    TimeInfo: "Time Info",
    SORRouteInfo: "SOR Route Info",
    TotalValue: "Total Value",
    ExecutedQty: "Executed Qty",
    OrigQty: "Original Qty",
    CompletionRate: "Completion Rate",
    Duration: "Duration",
    Hours: "Hours",
    Minutes: "Minutes",
    Seconds: "Seconds",
    Close: "Close",
    TradeHistory: "Trade History",
    NoTradeHistory: "No Trade History",
    TradeId: "Trade ID",
    Exchange: "Exchange",
    Total: "Total",
    Fee: "Fee",
    CopySuccess: "Copy Success",
    CopyFailed: "Copy Failed",
    RefreshFailed: "Refresh Failed",
    RefreshSuccess: "Refresh Success",
    OrderStopped: "Order Stopped",
    StopFailed: "Stop Failed",
    NoOrdersToStop: "No Orders to Stop",
    AllOrdersStopped: "All Orders Stopped",
    StopAllFailed: "Stop All Failed",
    StopConfirm: "Confirm to stop this order?",
    Yes: "Yes",
    No: "No",
    Status: {
      NEW: "New",
      PARTIALLY_FILLED: "Partially Filled",
      FILLED: "Filled",
      CANCELED: "Canceled",
      REJECTED: "Rejected",
      PENDING_CANCEL: "Pending Cancel",
    },
  },
  components_tradeheader: {
    menu: {
      trade: "Trade",
      aiTrade: "AI Trade",
      news: "News",
    },
    auth: {
      login: "Log In",
      signup: "Sign Up",
    },
    subAccount: {
      trigger: "Sub-account Selector",
    },
    user: {
      notLoggedIn: "Not Logged In",
    },
    userMenu: {
      manageSubAccount: "Manage Sub-accounts",
      stats: "Statistics",
      riskPanel: "Risk Control Panel",
      invite: "Invite & Rebate",
      settings: "Account Settings",
      logout: "Log Out",
    },
    messages: {
      title: "Messages",
      markAllRead: "Mark all as read",
      empty: "No messages",
      tradeType: "Trade Alerts",
      newsType: "Real-time News",
    },
    tradeDropdown: {
      favTitle: "Favorites",
      favDescription: "Manage your favorite trading pairs",
      spotDescription: "Easily buy and sell crypto digital currencies",
      contractDescription: "Trade perpetual and delivery contracts",
      futuresmktTitle: "Traditional Futures",
      futuresmktDescription: "Trade global commodity and index futures",
    },
    futuresmktPanel: {
      futuresTag: "Futures",
      categoryAll: "All",
      categorySoyChain: "Soy Complex",
      categoryGrains: "Grains",
      categoryUsIndex: "US Index",
      categoryPreciousMetals: "Precious Metals",
      categoryCommodityFx: "Commodity FX",
    },
    symbolSelect: {
      marketCrypto: "Crypto",
      marketFuturesmkt: "Traditional Futures",
    },
    language: {
      zh_CN: "简体中文",
      zh_TW: "繁體中文",
      en: "English",
    },
    modal: {
      loginTitle: "Log In",
      signupTitle: "Sign Up",
    },
  },
  components_apiselect: {
    searchPlaceholder: "Search sub-accounts",
    syncTooltip:
      "When the main account trades, active sub-accounts will follow this ratio",
    activateAll: "Activate All",
    disableAll: "Disable All",
    activate: "Activate",
    disable: "Disable",
    unnamedAccount: "Unnamed Account",
    mainTag: "Main",
    copyApiKey: "Copy API Key",
    syncScale: "Sync Ratio",
    emptyNoMatch: "No matching sub-accounts found",
    emptyNoApis: "No sub-accounts",
    activatedAllSuccess: "All accounts of {name} activated",
    disabledAllSuccess: "All accounts of {name} disabled",
    apiKeyEmpty: "API Key is empty",
    copySuccess: "API Key copied to clipboard",
    copyFailed: "Copy failed, please copy manually",
    noResult: "No matching symbols found",
    loadFailed: "Failed to load",
    retry: "Retry",
    searchSymbolPlaceholder: "Search symbols",
  },
  ManageSubAccountModal: {
    Title: "Manage Sub-accounts",
    AddButton: "+Add Sub-account",
    AccountCount: "{count} sub-account",
    AccountsCount: "{count} sub-accounts",
    Empty: "No sub-accounts",
    CopyApiKey: "Copy API Key",
    MaxAmount: "Max order amount:",
    Unlimited: "Unlimited",
    Edit: "Edit",
    Delete: "Delete",
    DeleteConfirmTitle:
      "Are you sure to delete this sub-account? This action cannot be undone",
    DeleteConfirmOk: "Delete",
    DeleteConfirmCancel: "Cancel",
    AddTitle: "Add Sub-account API",
    EditTitle: "Edit Sub-account API",
    Form: {
      Exchange: "Exchange",
      Name: "Name",
      ApiKey: "API Key",
      SecretKey: "Secret Key",
      Passphrase: "Passphrase",
      MaxAmount: "Max order amount (USDT)",
      MaxAmountPlaceholder:
        "Enter 0 to indicate no limit for the max order amount",
      AuthList: "Trade Permissions",
      SpotTrade: "Spot Trading",
      FutureTrade: "Futures Trading",
      SecretKeyEditLabel:
        "Secret Key (For security, the Secret Key will not be displayed)",
      PassphraseEditLabel:
        "Passphrase (For security, the Passphrase will not be displayed)",
      SecretKeyEditPlaceholder: "Leave empty to keep the original Secret Key",
      PassphraseEditPlaceholder: "Leave empty to keep the original Passphrase",
      NamePlaceholder: "Please enter name",
      ApiKeyPlaceholder: "Please enter API Key",
      SecretKeyPlaceholder: "Please enter Secret Key",
      PassphrasePlaceholder: "Please enter Passphrase",
      Save: "Save",
      Cancel: "Cancel",
    },
    Futuresmkt: {
      AccountNo: "Account No.",
      AccountNoPlaceholder: "Trading account, e.g. 30000018",
      PwdMd5: "Login Password MD5",
      PwdMd5Placeholder: "32-char lowercase MD5, not plaintext password",
      PwdMd5EditLabel: "Login Password MD5 (saved value hidden)",
      PwdMd5EditPlaceholder:
        "Leave empty to keep; if changing, use 32-char lowercase MD5",
      OrgCode: "Org Code",
      OrgCodePlaceholder: "Optional, e.g. trade; empty uses server default",
      OrgCodeEditLabel: "Org Code (saved value hidden)",
      OrgCodeEditPlaceholder: "Leave empty to keep",
    },
    Rules: {
      ExchangeRequired: "Please select exchange",
      NameRequired: "Please enter name",
      ApiKeyRequired: "Please enter API Key",
      SecretKeyRequired: "Please enter Secret Key",
      PassphraseRequired: "Please enter Passphrase",
      MaxAmountRequired: "Please enter max order amount",
      FuturesmktAccountNoRequired: "Please enter account no.",
      FuturesmktPwdMd5Required: "Please enter login password MD5",
      FuturesmktPwdMd5Invalid: "Must be 32-char lowercase hex MD5",
    },
    Messages: {
      CopySuccess: "API Key has been copied to clipboard",
      CopyFailed: "Copy failed, please copy manually",
      LoadFailed: "Failed to load sub-accounts",
      SaveSuccess: "Sub-account API info saved",
      SaveFailed: "Save failed",
      AddSuccess: "Sub-account API info added",
      AddFailed: "Save failed",
      DeleteSuccess: "Sub-account deleted",
      DeleteFailed: "Delete failed",
    },
  },
  txui: {
    fng: {
      title: "Fear & Greed Index",
      detail: "Detail",
      Day: "Day",
      Days: "Days",
      history: {
        yesterday: "Yesterday",
        lastWeek: "Last Week",
        lastMonth: "Last Month",
      },
      labels: {
        extremeGreed: "Extreme Greed",
        greed: "Greed",
        neutral: "Neutral",
        fear: "Fear",
        extremeFear: "Extreme Fear",
      },
      timeFilters: {
        all: "All",
        week: "1 week",
        month: "1 month",
        year: "1 year",
      },
    },
    user_account: {
      avatar: "Avatar",
      account_info: "Account Info",
      nickname: "Nickname",
      edit_nickname: "Edit",
      email: "Email",
      edit_email: "Change",
      security_method: "Security",
      phone: "Phone",
      edit_phone: "Change",
      login_password: "Password",
      edit_password: "Change",
      modal_nickname_title: "Change Nickname",
      new_nickname: "New Nickname",
      placeholder_nickname: "Enter new nickname",
      modal_email_title: "Change Email",
      new_email: "New Email",
      placeholder_email: "Enter new email",
      verification_code: "Verification Code",
      placeholder_code: "Enter code",
      send_code: "Send Code",
      modal_phone_title: "Change Phone",
      new_phone: "New Phone",
      placeholder_phone: "Enter new phone number",
      modal_password_title: "Change Password",
      old_password: "Old Password",
      placeholder_old_password: "Enter old password",
      new_password: "New Password",
      placeholder_new_password: "Enter new password",
      confirm_password: "Confirm Password",
      placeholder_confirm_password: "Confirm new password",
      cancel: "Cancel",
      confirm: "Confirm",
      nickname_success: "Nickname updated successfully",
      nickname_fail: "Failed to update nickname",
      email_success: "Email updated successfully",
      email_fail: "Failed to update email",
      phone_success: "Phone updated successfully",
      phone_fail: "Failed to update phone",
      password_success: "Password updated successfully",
      password_fail: "Failed to update password",
      update_fail: "Update failed, please try again",
      user_info_fail: "Failed to update user info",
      wait_retry: "Please wait {seconds} seconds",
      code_sent_email: "Code sent to email",
      code_fail: "Failed to send code",
      code_sent_phone: "Code sent to phone",
      copy_success: "Copied successfully",
      copy_fail: "Copy failed",
      valid_email: "Please enter a valid email",
      nickname_length: "Nickname must be 2-20 characters",
      valid_phone: "Please enter a valid 11-digit phone number",
      password_length: "Password must be at least 6 characters",
      password_mismatch: "Passwords do not match",
      input_new_nickname: "Please enter new nickname",
      input_new_email: "Please enter new email",
      input_new_phone: "Please enter new phone number",
      input_code: "Please enter verification code",
      input_old_password: "Please enter old password",
      input_new_password: "Please enter new password",
      input_confirm_password: "Please confirm new password",
    },
    monthSummary: {
      auth: "Authentication",
      inputPassword: "Please enter password to view monthly report",
      placeholder: "Please enter password",
      verify: "Verify",
      query: "Query",
      marketMakerReport: "Multi-Strategy Monthly Report",
      arbOptionReport: "Option Strategy Monthly Report",
      arbStatReport: "Statistical Arbitrage Monthly Report",
      arbStatStrategy: "Statistical Arbitrage Strategy",
      summary: "Summary:",
      summaryText1: "This report summarizes the performance of the ",
      summaryText2: " ",
      summaryText3: ". During this period, the absolute return was ",
      summaryText4: "%, and the maximum drawdown was ",
      summaryText5:
        "%, showing good profitability and risk resistance in market fluctuations.",
      netValueCurve: "Net Value Curve",
      exportNetValue: "Export Net Value",
      dataSource: "Data is sourced from a third-party custodial account",
      drawdownCurve: "Drawdown Curve",
      performanceMetrics: "{date} Performance Metrics",
      absoluteReturn: "Absolute Return",
      annualizedReturn: "Annualized Return",
      sharpeRatio: "Sharpe Ratio",
      maxDrawdown: "Max Drawdown",
      marketEnvironmentAnalysis: "Market Environment Analysis:",
      disclaimer: "Disclaimer: ",
      disclaimerText:
        "This report does not predict or guarantee any future performance and should not be considered any commitment or offer from our company. This document is not intended for any promotional purposes and does not constitute investment advice or an offer to anyone. Market investments carry risks, please treat them with caution.",
      dataSourceDisclaimer: "Data Source Disclaimer: ",
      dataSourceText: "Data is sourced from a third-party custodial account.",
      copyrightDisclaimer: "Copyright Disclaimer: ",
      copyrightText:
        "The copyright of this report belongs to TradingX. Without written authorization, no institution or individual may copy, disseminate, or use it for commercial purposes in any form.",
      passwordError: "Incorrect password, please try again",
      marketMakerStrategy: "Multi-Strategy ",
      optionStrategy: "Option Strategy ",
      dateMonth: "in {year}-{month}",
      dateRange: "from {startYear}-{startMonth} to {endYear}-{endMonth}",
      dateDisplayMonth: "{year}-{month}",
      dateDisplayRange: "{startYear}-{startMonth} to {endYear}-{endMonth}",
      netValue: "Net Value",
      drawdown: "Drawdown",
    },
  },
  views_riskControl: {
    header: {
      title: "Risk Control Panel",
      subtitle:
        "Monitor portfolio risk and returns by strategy instance group with backtest-style time ranges.",
    },
    tabs: {
      accountRisk: "Account Risk",
      strategyList: "Strategy Risk",
      overviewExposure: "Strategy Review",
    },
    filter: {
      timeRange: "Time Range",
      preset1d: "1d",
      preset7d: "7d",
      preset30d: "30d",
      presetMtd: "MTD",
      presetYtd: "YTD",
      presetLastMonth: "Last month",
      presetWeek: "Week to Date",
      presetMonth: "Month to Date",
      presetYear: "Year to Date",
      presetCustom: "Custom",
      customRange: "Custom Range",
      startDate: "Start Date",
      endDate: "End Date",
      apiAccounts: "API Accounts (multi-select)",
      selectApiPlaceholder: "Select API accounts",
      apiNotFound: "No matching API accounts",
      strategyInstances: "Strategy Instances (multi-select = portfolio)",
      selectStrategyPlaceholder: "Select strategy instances",
      strategyNotFound: "No matching strategies",
    },
    overview: {
      title: "Overview",
      periodRange: "{start} ~ {end}",
      startNetAsset: "Period-Start Net Assets",
      endNetAsset: "Period-End Net Assets",
      intervalPnl: "Period P&L",
      returnRate: "Period Return",
      annualizedReturn: "Annualized Period Return",
      maxDrawdown: "Period Max Drawdown",
      navVolatility: "Period NAV Volatility (Ann.)",
      sharpeRatio: "Period Sharpe Ratio",
      chartEquityDrawdown: "Cumulative NAV & Drawdown",
      chartNetAssetPnl: "Net Assets & Period P&L",
    },
    exposure: {
      title: "Exposure & Leverage",
      netExposureRate: "Avg Net Exposure (Period)",
      absExposureRate: "Avg Gross Exposure (Period)",
      avgExposureRate: "Avg Exposure (Period)",
      avgLeverage: "Avg Leverage (Period)",
      maxLeverage: "Peak Leverage (Period)",
      chartExposureLeverage: "Net / Gross Exposure & Leverage",
      chartAvgExposureTrend: "Avg Exposure Trend",
      chartContribution: "Strategy P&L Contribution (Stacked)",
      chartDistribution: "Exposure Distribution (Net)",
    },
    accountOverview: {
      title: "Account Overview",
      totalAsset: "Total Assets",
      todayPnl: "Today P&L",
      exposureRate: "Current Exposure",
      leverageRate: "Leverage",
      navChartTitle: "NAV Trend",
      navSeries: "Account NAV",
      navRange24h: "24H",
      navRange7d: "7D",
      navRange1w: "1W",
      navRange1m: "1M",
      navRange1y: "1Y",
    },
    lendingInfo: {
      title: "Lending & Borrowing",
      columns: {
        apiAccount: "API Account",
        side: "Side",
        asset: "Asset",
        amount: "Amount",
        annualRate: "Annual Rate",
        currentInterest: "Accrued Interest",
        notionalValue: "Notional Value",
      },
      side: {
        borrow: "Borrow",
        lend: "Lend",
      },
    },
    fundFlow: {
      title: "Fund Activity",
      filterAll: "All APIs",
      filterApiPlaceholder: "Filter by API",
      columns: {
        time: "Time",
        apiAccount: "API Account",
        type: "Type",
        amount: "Amount",
        balanceAfter: "Balance After",
        remark: "Remark",
      },
      type: {
        deposit: "Deposit",
        withdraw: "Withdraw",
        transferIn: "Transfer In",
        transferOut: "Transfer Out",
        fee: "Fee",
      },
    },
    strategyList: {
      title: "Live Strategy List",
      refresh: "Refresh",
      riskFilterAll: "All Status",
      riskFilterNormal: "Normal",
      riskFilterWarning: "Warning",
      riskFilterDanger: "Danger",
      riskFilterDisabled: "Disabled",
      stopAll: "Stop All Strategies",
      confirmStop: "Confirm Stop",
      cancel: "Cancel",
      confirmStopAllTitle: "Stop all strategies?",
      confirmStopAllDesc:
        "This will stop all running strategy instances. Please confirm carefully.",
      save: "Save",
      edit: "Edit",
      riskInfo: "Risk Info",
      confirmStopStrategyTitle: "Stop this strategy?",
      confirmStopStrategyDesc:
        "After stopping, this strategy instance will no longer execute new orders.",
      stopped: "Stopped",
      stopStrategy: "Stop Strategy",
      columns: {
        strategy: "Strategy",
        riskStatus: "Risk Status",
        totalAsset: "Total Assets",
        todayPnl: "Realized P&L",
        currentPnl: "Unrealized P&L",
        returnRate: "Return",
        intradayDrawdown: "Intraday Drawdown",
        maxDrawdown: "Max Drawdown",
        exposureRate: "Current Exposure",
        leverageRate: "Leverage",
        sharpeRatio: "Sharpe Ratio",
        riskEnabled: "Risk Control",
        warnSettings: "Warning Thresholds",
        dangerSettings: "Danger Thresholds",
        dangerActions: "On Danger Trigger",
        runningTime: "Runtime",
        action: "Actions",
      },
      runningTimeFormat: {
        daysHoursMinutes: "{days}d {hours}h {minutes}m",
        hoursMinutesSeconds: "{hours}h {minutes}m {seconds}s",
        stopped: " (Stopped)",
      },
      threshold: {
        maxDrawdown: "Max Drawdown",
        leverage: "Leverage",
        netExposure: "Net Exposure",
        absExposure: "Gross Exposure",
      },
    },
    dangerAction: {
      log: "Log Only",
      notify: "Alert",
      reduceOnly: "Reduce Only",
      blockNewPosition: "Block New Positions",
      stopStrategy: "Stop Strategy",
    },
    riskInfoModal: {
      title: "Risk Status",
      statusTitle: "Risk Status",
      currentRiskLevel: "Current Risk Level",
      currentTriggers: "Active Triggers",
      lastTriggerTime: "Last Trigger Time",
      alertList: "Alerts",
      filterAll: "All",
      filterWarning: "Warning",
      filterDanger: "Danger",
      noAlerts: "No alerts",
      triggerRecords: "Trigger History (Latest 20)",
      noTriggerRecords: "No trigger records",
      alertMeta: "Current {current} / Threshold {threshold}",
    },
    riskLevel: {
      disabled: "Off",
      danger: "Danger",
      warning: "Warning",
      normal: "Normal",
    },
    riskStatus: {
      riskDisabled: "Risk control disabled",
      noTrigger: "No triggers",
    },
    metrics: {
      maxDrawdown: "Max Drawdown",
      leverage: "Leverage",
      netExposureRate: "Net Exposure",
      absExposureRate: "Gross Exposure",
    },
    event: {
      drawdownDesc: "Current {value}%, threshold reached",
      leverageDesc: "Current {value}x, threshold reached",
    },
    chart: {
      cumulativeNav: "Cumulative NAV",
      drawdown: "Drawdown",
      drawdownPercent: "Drawdown (%)",
      netAsset: "Net Assets",
      intervalPnl: "Period P&L",
      intervalPnlProfit: "Period P&L (Gain)",
      intervalPnlLoss: "Period P&L (Loss)",
      netExposureRate: "Net Exposure",
      absExposureRate: "Gross Exposure",
      leverage: "Leverage",
      exposureRatePercent: "Exposure (%)",
      avgExposureRate: "Avg Exposure",
      sampleCount: "Sample Count",
    },
  },
};
